import React from 'react';
import Flip from '../../Configuration/Render/SVG/flip';
import varsityImage from './rackImages/varsity_reduced.png';
import verticalImage from './rackImages/unit_vertical.png';
import doubleImage from './rackImages/unit_double_docker.png';
import {
  DOUBLE_WIDTH,
  VARSITY_WIDTH,
  VERTICAL_WIDTH,
  VARSITY_DEPTH,
  VERTICAL_DEPTH,
  DOUBLE_DEPTH
} from '../configurator';
const VARSITY_SVG = (rotate = 0) => {
  return (
    <g
      transform={`rotate(${rotate})`}
      style={{
        strokeWidth: 0.24,
        stroke: 'black',
        fill: 'none',
        fillOpacity: 0
      }}
    >
      <path
        d='M58.6,800.3c0,8.33-.09,16.69.17,25a2.6,2.6,0,0,0,.47,1.91,1.8,1.8,0,0,0,2.18.26c1.25-.79.82-3.45.79-4.69q-.12-6.35-.12-12.7'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M62.1,806.2v-6' transform='translate(-19.98 -710.18)' />
      <path
        d='M59.4,788.8c-.32.29-.88.83-.8,1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M62.2,826c0-8.6-.1-17.2-.1-25.8'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M36.7,781.4v4.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M36.7,791.4c.36,6.89.06,13.81.18,20.71,0,1.61,0,3.22,0,4.83,0,1.23.79,2.21,2.14,1.93,2.23-.46,1.27-4.2,1.27-5.73,0-4,.09-8-.1-11.93'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M40.2,797.5v-6.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M37.5,780a1.55,1.55,0,0,0-.8,1.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M40.3,817.3c0-8.63-.1-17.27-.1-25.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M58.3,720.7c0,9.9.1,19.8.1,29.7'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M61.9,755v-1.5' transform='translate(-19.98 -710.18)' />
      <path
        d='M61.9,750.4c0-3.69-.1-7.4-.1-11.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.8,738.1c0-2.41,0-4.83,0-7.24,0-1.14.07-2.28,0-3.42s-.21-2.28-.19-3.44c0-1.31.53-4.07-1-4.76a1.63,1.63,0,0,0-2.36,1.46'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M61.9,755v-1.5' transform='translate(-19.98 -710.18)' />
      <path
        d='M36.3,711.8c0,10,.1,19.93.1,29.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M39.9,746.3v-1.6' transform='translate(-19.98 -710.18)' />
      <path
        d='M39.9,741.5c0-3.67-.1-7.33-.1-11'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.8,729.2c0-4.77-.26-9.56-.1-14.32,0-1.21.5-2.83-.24-3.91a1.8,1.8,0,0,0-3.16.83'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M39.9,746.3v-1.6' transform='translate(-19.98 -710.18)' />
      <line x1='36.22' y1='37.52' x2='28.12' y2='35.72' />
      <line x1='27.82' y1='37.32' x2='35.92' y2='39.12' />
      <line x1='0.52' y1='39.32' x2='8.62' y2='37.42' />
      <line x1='8.12' y1='35.82' x2='0.12' y2='37.62' />
      <path d='M46.5,747.5h1.3' transform='translate(-19.98 -710.18)' />
      <path
        d='M48.1,745.9a5.76,5.76,0,0,0-2.3,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M28.6,747.6a10.73,10.73,0,0,0,1.3,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M30.6,746a7.48,7.48,0,0,0-2.5,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M44.2,748a22.25,22.25,0,0,0,2.3-.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.8,745.9a3.07,3.07,0,0,1-1.6.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M29.9,747.6a11.62,11.62,0,0,0,2.3.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M32.2,746.3c-.49,0-1.31,0-1.6-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='18.92' y1='37.82' x2='24.22' y2='37.82' />
      <line x1='12.22' y1='37.82' x2='17.52' y2='37.82' />
      <line x1='24.22' y1='36.02' x2='12.22' y2='36.12' />
      <line x1='17.22' y1='37.82' x2='17.22' y2='40.02' />
      <line x1='19.12' y1='40.02' x2='19.12' y2='37.82' />
      <line x1='19.52' y1='36.12' x2='19.52' y2='34.92' />
      <line x1='16.92' y1='34.92' x2='16.92' y2='36.12' />
      <line x1='19.42' y1='72.12' x2='19.32' y2='66.12' />
      <line x1='17.12' y1='40.22' x2='17.22' y2='64.52' />
      <line x1='19.52' y1='64.52' x2='19.42' y2='40.22' />
      <line x1='19.62' y1='34.92' x2='19.62' y2='34.82' />
      <line x1='16.72' y1='34.82' x2='16.72' y2='34.92' />
      <line x1='19.32' y1='33.92' x2='19.32' y2='33.82' />
      <line x1='17.12' y1='33.82' x2='17.12' y2='33.92' />
      <line x1='22.72' y1='32.02' x2='22.72' y2='31.22' />
      <line x1='13.62' y1='31.22' x2='13.62' y2='32.12' />
      <line x1='22.52' y1='30.72' x2='22.42' y2='19.92' />
      <line x1='20.62' y1='20.42' x2='20.62' y2='30.72' />
      <line x1='15.72' y1='30.82' x2='15.72' y2='20.52' />
      <line x1='13.72' y1='19.92' x2='13.92' y2='30.82' />
      <path
        d='M31.3,780.2a5,5,0,0,0-2.29-.06c-.9.06-1.81.07-2.71.06'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M26.3,781.7c.26.35,1.31.13,1.67.12,1,0,2,0,3,0'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='11.82' y1='71.12' x2='11.52' y2='71.12' />
      <line x1='11.52' y1='72.22' x2='11.82' y2='72.22' />
      <line x1='12.62' y1='71.32' x2='11.82' y2='71.32' />
      <line x1='11.82' y1='72.02' x2='13.02' y2='72.02' />
      <line x1='6.32' y1='72.12' x2='11.32' y2='72.02' />
      <line x1='12.32' y1='65.72' x2='12.52' y2='71.32' />
      <line x1='13.42' y1='71.62' x2='13.62' y2='66.42' />
      <line x1='22.52' y1='72.12' x2='22.62' y2='72.12' />
      <line x1='22.62' y1='59.22' x2='22.52' y2='59.22' />
      <path
        d='M40.8,729.3c-.06-.33-.11-1.64-.5-1.6'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='20.32' y1='21.82' x2='20.52' y2='21.82' />
      <line x1='20.32' y1='17.52' x2='20.02' y2='19.02' />
      <path
        d='M36.2,729.3c-.07-.37-.11-1.45-.4-1.6'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='15.82' y1='21.92' x2='16.02' y2='21.92' />
      <line x1='15.82' y1='17.52' x2='15.42' y2='19.12' />
      <line x1='21.62' y1='67.32' x2='21.72' y2='67.32' />
      <line x1='21.72' y1='64.02' x2='21.52' y2='64.02' />
      <line x1='15.12' y1='64.02' x2='15.02' y2='64.02' />
      <line x1='15.02' y1='67.32' x2='15.22' y2='67.32' />
      <line x1='17.22' y1='64.22' x2='15.12' y2='64.22' />
      <line x1='19.52' y1='67.12' x2='21.62' y2='67.12' />
      <line x1='15.22' y1='67.12' x2='17.22' y2='67.12' />
      <line x1='20.72' y1='91.02' x2='21.12' y2='89.52' />
      <path
        d='M41.1,798.9a4.92,4.92,0,0,0-.3-1.06c-.22-.38-.06-.34-.6-.34'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='16.82' y1='87.32' x2='16.22' y2='87.32' />
      <line x1='16.22' y1='91.12' x2='16.82' y2='91.12' />
      <line x1='20.22' y1='91.02' x2='20.72' y2='91.02' />
      <line x1='16.22' y1='87.32' x2='15.92' y2='88.82' />
      <line x1='15.92' y1='89.52' x2='16.22' y2='91.12' />
      <line x1='20.02' y1='19.02' x2='19.82' y2='19.12' />
      <line x1='16.42' y1='19.12' x2='16.22' y2='19.12' />
      <line x1='16.22' y1='20.32' x2='16.42' y2='20.32' />
      <line x1='19.82' y1='20.32' x2='20.02' y2='20.32' />
      <line x1='19.32' y1='68.52' x2='20.22' y2='70.42' />
      <line x1='20.82' y1='70.02' x2='19.52' y2='67.12' />
      <line x1='16.62' y1='70.42' x2='17.52' y2='68.62' />
      <line x1='17.22' y1='67.12' x2='15.92' y2='70.02' />
      <path
        d='M40.2,780.6a2.75,2.75,0,0,1,.3,1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.2,781.5a5.26,5.26,0,0,0-.4-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M36.3,781.6a2.68,2.68,0,0,1,.3-1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M35.9,780.2l-.4,1.4' transform='translate(-19.98 -710.18)' />
      <line x1='20.52' y1='71.42' x2='20.82' y2='76.92' />
      <line x1='22.22' y1='88.72' x2='21.72' y2='80.22' />
      <line x1='21.62' y1='77.92' x2='21.22' y2='71.32' />
      <line x1='15.42' y1='88.82' x2='15.92' y2='81.02' />
      <line x1='16.12' y1='76.92' x2='16.32' y2='71.42' />
      <line x1='15.52' y1='71.42' x2='15.22' y2='77.82' />
      <line x1='21.72' y1='66.12' x2='22.52' y2='66.12' />
      <line x1='22.52' y1='65.22' x2='21.72' y2='65.22' />
      <line x1='15.02' y1='65.22' x2='14.42' y2='65.22' />
      <line x1='14.42' y1='66.12' x2='15.02' y2='66.12' />
      <line x1='24.42' y1='65.52' x2='24.22' y2='59.82' />
      <line x1='23.32' y1='59.72' x2='23.12' y2='64.52' />
      <line x1='21.52' y1='88.72' x2='21.12' y2='88.72' />
      <line x1='22.72' y1='88.72' x2='22.22' y2='88.72' />
      <line x1='21.12' y1='89.52' x2='22.72' y2='89.52' />
      <line x1='14.82' y1='88.82' x2='14.22' y2='88.82' />
      <line x1='15.92' y1='88.82' x2='15.42' y2='88.82' />
      <line x1='14.22' y1='89.52' x2='15.92' y2='89.52' />
      <line x1='23.82' y1='64.52' x2='22.62' y2='64.52' />
      <line x1='30.52' y1='60.12' x2='30.62' y2='60.12' />
      <line x1='30.62' y1='59.12' x2='30.52' y2='59.12' />
      <line x1='25.42' y1='60.02' x2='30.42' y2='60.02' />
      <line x1='30.42' y1='59.22' x2='25.42' y2='59.42' />
      <line x1='58.22' y1='46.32' x2='50.12' y2='44.52' />
      <line x1='49.72' y1='46.22' x2='57.82' y2='48.02' />
      <line x1='22.42' y1='48.12' x2='30.52' y2='46.32' />
      <line x1='30.22' y1='44.62' x2='22.12' y2='46.52' />
      <path
        d='M68.4,756.4c.25-.24,1-.1,1.3,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M70.1,754.7a5,5,0,0,0-2.4.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.5,756.5a6.89,6.89,0,0,1,1.4-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M52.5,754.8a5.9,5.9,0,0,0-2.3,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M66.1,756.7a11.52,11.52,0,0,0,2.3-.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M67.7,754.8c-.51,0-1.06.2-1.6.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M51.9,756.4a4.17,4.17,0,0,0,2.2.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M54.1,755c-.36,0-1.33,0-1.6-.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='40.92' y1='46.52' x2='46.12' y2='46.52' />
      <line x1='34.12' y1='46.52' x2='39.42' y2='46.52' />
      <line x1='46.12' y1='44.82' x2='34.12' y2='44.82' />
      <line x1='39.22' y1='46.52' x2='39.22' y2='48.92' />
      <line x1='41.12' y1='48.92' x2='41.12' y2='46.52' />
      <line x1='41.42' y1='44.82' x2='41.42' y2='43.72' />
      <line x1='38.82' y1='43.72' x2='38.82' y2='44.82' />
      <path
        d='M61.2,785.1V791l-.09-26.57V760.7'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='39.12' y1='49.12' x2='39.22' y2='73.32' />
      <line x1='41.42' y1='73.32' x2='41.32' y2='49.02' />
      <line x1='39.12' y1='42.72' x2='39.12' y2='42.82' />
      <line x1='44.72' y1='40.92' x2='44.72' y2='40.02' />
      <line x1='35.62' y1='40.12' x2='35.62' y2='40.82' />
      <line x1='44.52' y1='39.42' x2='44.52' y2='28.62' />
      <line x1='42.52' y1='29.32' x2='42.52' y2='39.62' />
      <line x1='37.62' y1='39.62' x2='37.62' y2='29.32' />
      <line x1='35.72' y1='28.62' x2='35.82' y2='37.42' />
      <path
        d='M53.2,789c-1,0-2.09,0-3.13,0-.41,0-1.49-.27-1.77.12'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M48.3,790.5c.32.42,1.65.17,2.08.14a9.77,9.77,0,0,0,2.82-.14'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='33.32' y1='81.02' x2='33.82' y2='81.02' />
      <line x1='34.62' y1='80.12' x2='33.82' y2='80.12' />
      <line x1='33.82' y1='80.82' x2='34.92' y2='80.72' />
      <line x1='28.32' y1='80.82' x2='33.22' y2='80.82' />
      <line x1='34.22' y1='74.52' x2='34.42' y2='80.12' />
      <line x1='35.32' y1='80.42' x2='35.62' y2='75.22' />
      <line x1='44.52' y1='80.82' x2='44.62' y2='80.82' />
      <line x1='44.62' y1='68.02' x2='44.52' y2='68.02' />
      <path
        d='M62.8,738.1c-.08-.33-.21-1.64-.6-1.6'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='42.22' y1='30.72' x2='42.42' y2='30.72' />
      <path
        d='M58.2,738.1c-.09-.37-.19-1.45-.5-1.6'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='37.72' y1='30.72' x2='37.92' y2='30.72' />
      <line x1='37.72' y1='26.32' x2='37.42' y2='28.02' />
      <line x1='37.62' y1='30.22' x2='37.72' y2='30.72' />
      <line x1='43.42' y1='76.12' x2='43.72' y2='76.12' />
      <line x1='43.72' y1='72.72' x2='43.42' y2='72.72' />
      <line x1='37.02' y1='72.72' x2='36.92' y2='72.72' />
      <line x1='36.92' y1='76.12' x2='37.02' y2='76.12' />
      <line x1='39.22' y1='73.02' x2='37.02' y2='73.02' />
      <line x1='41.42' y1='76.02' x2='43.42' y2='75.92' />
      <line x1='37.02' y1='76.02' x2='39.22' y2='76.02' />
      <line x1='42.72' y1='99.92' x2='43.02' y2='98.32' />
      <path
        d='M63,807.8a7.08,7.08,0,0,0-.23-1.24c-.18-.44-.1-.36-.67-.36'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='38.72' y1='96.02' x2='38.22' y2='96.02' />
      <line x1='38.22' y1='99.92' x2='38.72' y2='99.92' />
      <line x1='42.12' y1='99.92' x2='42.72' y2='99.92' />
      <line x1='38.22' y1='96.02' x2='37.82' y2='97.62' />
      <line x1='37.82' y1='98.32' x2='38.22' y2='99.92' />
      <line x1='42.02' y1='27.92' x2='41.82' y2='27.92' />
      <line x1='38.42' y1='27.92' x2='38.22' y2='27.92' />
      <line x1='38.22' y1='29.12' x2='38.42' y2='29.12' />
      <line x1='41.82' y1='29.12' x2='42.02' y2='29.12' />
      <line x1='44.62' y1='75.62' x2='45.72' y2='75.62' />
      <line x1='35.92' y1='28.12' x2='34.42' y2='28.12' />
      <line x1='34.42' y1='29.02' x2='35.72' y2='28.92' />
      <line x1='41.22' y1='77.42' x2='42.12' y2='79.22' />
      <line x1='42.82' y1='78.82' x2='41.42' y2='76.02' />
      <line x1='38.52' y1='79.22' x2='39.32' y2='77.42' />
      <line x1='39.22' y1='76.02' x2='37.82' y2='78.92' />
      <path
        d='M62.1,789.4a1.65,1.65,0,0,1,.2,1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M63.1,790.4a10.2,10.2,0,0,0-.3-1.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M58.3,790.4a2.34,2.34,0,0,1,.2-1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M57.8,789.1a7.07,7.07,0,0,0-.3,1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='42.32' y1='80.22' x2='42.72' y2='85.72' />
      <line x1='42.92' y1='89.72' x2='43.42' y2='97.62' />
      <line x1='44.12' y1='97.52' x2='43.72' y2='89.12' />
      <line x1='43.62' y1='86.72' x2='43.12' y2='80.22' />
      <line x1='37.92' y1='85.72' x2='38.32' y2='80.22' />
      <line x1='37.52' y1='80.22' x2='37.12' y2='86.72' />
      <line x1='46.42' y1='74.42' x2='46.12' y2='68.72' />
      <line x1='45.22' y1='68.52' x2='45.02' y2='73.32' />
      <line x1='43.42' y1='97.52' x2='43.02' y2='97.62' />
      <line x1='44.72' y1='97.52' x2='44.12' y2='97.52' />
      <line x1='43.02' y1='98.32' x2='44.72' y2='98.32' />
      <line x1='36.62' y1='97.62' x2='36.12' y2='97.62' />
      <line x1='37.82' y1='97.62' x2='37.42' y2='97.62' />
      <line x1='36.12' y1='98.42' x2='37.82' y2='98.32' />
      <line x1='45.72' y1='73.32' x2='44.62' y2='73.32' />
      <line x1='46.82' y1='69.02' x2='47.22' y2='69.02' />
      <line x1='47.22' y1='67.92' x2='46.82' y2='67.92' />
      <line x1='47.42' y1='68.82' x2='52.32' y2='68.82' />
      <line x1='52.32' y1='68.02' x2='47.42' y2='68.12' />
      <line x1='35.52' y1='42.12' x2='35.62' y2='42.02' />
      <line x1='22.62' y1='42.02' x2='22.72' y2='42.02' />
      <line x1='32.82' y1='34.72' x2='32.82' y2='34.82' />
      <line x1='25.42' y1='34.82' x2='25.32' y2='34.72' />
      <path
        d='M45.1,745.3a.19.19,0,0,0,.1.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M51,750.8c0,.6,1,1,1.43,1.19.89.48,1.72,1.07,2.57,1.61'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M52,749.3a3.27,3.27,0,0,0-.7-.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='35.52' y1='40.82' x2='32.02' y2='39.12' />
      <path
        d='M55,753.6c.36.29.57.59.9.9'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='35.92' y1='41.02' x2='35.52' y2='40.82' />
      <line x1='36.12' y1='41.12' x2='35.92' y2='41.02' />
      <line x1='21.82' y1='39.02' x2='21.62' y2='39.12' />
      <path
        d='M42.3,749.4q.06-.26-.2-.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.6,749.3a.26.26,0,0,0-.1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.12' y1='39.02' x2='21.82' y2='39.02' />
      <line x1='21.82' y1='38.42' x2='21.72' y2='38.42' />
      <path
        d='M42.3,748.9c.11-.4-.21-.3-.5-.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.7,748.6a.29.29,0,0,0-.2.4'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='26.62' y1='32.72' x2='26.22' y2='32.92' />
      <path
        d='M47,743.2c-.21-.19-.09-.3-.4-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='24.72' y1='36.02' x2='27.12' y2='33.72' />
      <path
        d='M47.1,743.9a.19.19,0,0,0,.1-.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='32.02' y1='32.82' x2='31.62' y2='32.72' />
      <path
        d='M51.6,742.9c-.15,0-.22,0-.3.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M51.3,743a.19.19,0,0,1-.1.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M51,743.7c.18.83,1.37,1.37,2,1.9s1.19,1.63,2,1.8'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M43.2,753.6c.76-.53,1.56-1,2.29-1.59.32-.25,1.71-1.09,1.71-1.31'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M46.9,749.1a3.27,3.27,0,0,0-.7.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='26.12' y1='39.02' x2='22.72' y2='40.72' />
      <line x1='26.92' y1='38.92' x2='26.92' y2='39.02' />
      <path
        d='M42.3,754.5a1.81,1.81,0,0,1,.9-.9'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.72' y1='40.72' x2='22.32' y2='40.92' />
      <line x1='22.32' y1='40.92' x2='22.02' y2='41.12' />
      <path
        d='M42,751.3c-.23.23-.54.44-.5.8'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M42.1,751.2a.5.5,0,0,0-.6.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.8,750.5a.43.43,0,0,0-.3.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M42.3,750.7c-.1-.27-.24-.2-.5-.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.8,749.9a.48.48,0,0,0-.3.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M42.3,750c-.09-.17-.27-.1-.5-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M41.5,750v.3' transform='translate(-19.98 -710.18)' />
      <line x1='27.72' y1='32.62' x2='27.72' y2='35.62' />
      <line x1='30.52' y1='36.22' x2='30.52' y2='32.62' />
      <path
        d='M38.9,748c-.27-.47-1-.37-1.4,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.1,750.2c-.16.16-1.74.24-1.9,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M40.4,786.8c-.65,0-1.18.49-1.82.57a4.39,4.39,0,0,1-2.18-.57'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M38.5,790.4a2,2,0,0,0,3.6-1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='19.12' y1='71.22' x2='20.42' y2='76.62' />
      <line x1='16.42' y1='76.62' x2='17.62' y2='71.22' />
      <path
        d='M42.1,789.4a3.55,3.55,0,0,0-.2-1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.5,745.1c0-1.45-2.6-1.46-2.6,0'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='19.32' y1='65.92' x2='19.32' y2='66.12' />
      <path
        d='M39.3,775.3a.66.66,0,0,0,.2-.6'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M37.2,774.7a.68.68,0,0,0,.1.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M36.7,745a1.5,1.5,0,0,1,1.54-1.19A1.33,1.33,0,0,1,39.6,745'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M37.1,744a1.07,1.07,0,0,1,1.26-.88c.45.13.57.63.94.88'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M40.6,741.8c0-1.06,3.22-.32,1.7,1.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M40.6,741c.07-.48.67-.62,1.07-.56a1.37,1.37,0,0,1,1,1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M34,743c-.6-.15-.42-1-.09-1.32a1.33,1.33,0,0,1,1.89.12'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M33.6,741.4c0-.39.47-.77.81-.87.64-.2.9.2,1.39.47'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M35.8,741.8c.35.85,1.35.9,2.1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M38.5,742.7a2.4,2.4,0,0,0,2.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M38.5,741.9a2.72,2.72,0,0,0,2.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M35.8,741a2.14,2.14,0,0,0,2.1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M42.4,730.1v-.6' transform='translate(-19.98 -710.18)' />
      <path
        d='M42.4,729.5c-1-1-1.88,0-1.8,1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M35.7,730.7c.07-.47-.31-.81-.3-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M35.4,729.4c-.82-.82-1.31.06-1.7.7'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M31.5,781.3l-.1-1.2.1,1' transform='translate(-19.98 -710.18)' />
      <line x1='11.52' y1='72.12' x2='11.52' y2='70.92' />
      <path
        d='M31.4,780.1c-.14.14-.1.42-.1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M31.5,781.1c-.25.06-.2-.05-.2-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='6.32' y1='70.02' x2='6.32' y2='69.92' />
      <path d='M26.3,782.3v-1.2' transform='translate(-19.98 -710.18)' />
      <line x1='6.32' y1='70.82' x2='6.32' y2='71.52' />
      <path
        d='M31.3,781.1a8.67,8.67,0,0,0,0,2.18c.22.72.2-.71.2-1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M31.8,781.5v.7' transform='translate(-19.98 -710.18)' />
      <path
        d='M33.3,775.3c-.54,0-1,0-1,.6'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M33.6,776.6a1.78,1.78,0,0,0-.3-.6'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M31.5,782.4v1.1' transform='translate(-19.98 -710.18)' />
      <path d='M42.5,769.4v12.9' transform='translate(-19.98 -710.18)' />
      <path d='M42.6,774.7v.8' transform='translate(-19.98 -710.18)' />
      <line x1='22.62' y1='64.62' x2='22.62' y2='65.32' />
      <path d='M40.5,727.7V732' transform='translate(-19.98 -710.18)' />
      <path d='M40.3,727.7V732' transform='translate(-19.98 -710.18)' />
      <line x1='20.02' y1='19.02' x2='20.02' y2='20.32' />
      <line x1='16.22' y1='19.12' x2='16.22' y2='20.32' />
      <path
        d='M35.9,727.7c0,1.46.1,2.92.1,4.4'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M35.8,727.7v4.4' transform='translate(-19.98 -710.18)' />
      <line x1='21.52' y1='64.02' x2='21.62' y2='67.32' />
      <path d='M41.7,776.3v-.9' transform='translate(-19.98 -710.18)' />
      <path
        d='M35.2,777.5a30.47,30.47,0,0,0-.1-3.3v.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='15.02' y1='64.02' x2='15.02' y2='67.32' />
      <line x1='15.12' y1='64.22' x2='15.22' y2='67.12' />
      <line x1='19.32' y1='67.02' x2='19.52' y2='67.12' />
      <line x1='17.22' y1='67.12' x2='17.32' y2='67.12' />
      <path d='M40.7,797.5v3.7' transform='translate(-19.98 -710.18)' />
      <path d='M36.2,797.5v3.8' transform='translate(-19.98 -710.18)' />
      <path d='M43.8,774.8v1.6' transform='translate(-19.98 -710.18)' />
      <path d='M43.8,776.4v-1.7' transform='translate(-19.98 -710.18)' />
      <path d='M34.4,776.3v-.9' transform='translate(-19.98 -710.18)' />
      <line x1='13.32' y1='65.42' x2='13.32' y2='65.82' />
      <line x1='13.32' y1='65.42' x2='13.32' y2='64.62' />
      <path d='M41.5,799.4v-.5' transform='translate(-19.98 -710.18)' />
      <path d='M34.8,799.4V799' transform='translate(-19.98 -710.18)' />
      <path
        d='M44.2,770c-.18-.26,0-.48-.41-.54a.44.44,0,0,0-.49.44'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.5,770.3l.1,1.8c0-1.53-.09-3.07-.1-4.6v1.8'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M50.6,769.3v1' transform='translate(-19.98 -710.18)' />
      <line x1='30.42' y1='57.32' x2='30.52' y2='57.32' />
      <line x1='30.42' y1='57.32' x2='30.42' y2='57.42' />
      <line x1='25.22' y1='59.72' x2='25.22' y2='57.42' />
      <path
        d='M45.4,767.6v4.5h-.1l-.1-2.2'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M45.4,770.8v1.3' transform='translate(-19.98 -710.18)' />
      <path d='M45.4,769.6v-2' transform='translate(-19.98 -710.18)' />
      <line x1='25.42' y1='60.02' x2='25.42' y2='61.92' />
      <path d='M50.6,769.3v1' transform='translate(-19.98 -710.18)' />
      <path
        d='M60.9,756.7c-.25.07-.44-.15-.7-.2s-.58.24-.8.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.1,759.1a3.63,3.63,0,0,1-1.9,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M62.3,795.5c-.07.32-1.2.55-1.47.61a4.77,4.77,0,0,1-2.43-.41'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M56.8,798.1a2,2,0,0,0,3.5,1.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='41.12' y1='79.92' x2='42.32' y2='85.32' />
      <path
        d='M58.4,795.7a10.37,10.37,0,0,1,.51-2.71c.22-1,.39-1.93.59-2.89'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M57,797.3a2.35,2.35,0,0,0-.2.8'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.4,753.9c0-1.45-2.6-1.44-2.6,0'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='41.22' y1='74.82' x2='41.22' y2='74.92' />
      <path
        d='M61.2,784.1a1.82,1.82,0,0,1,.2-.6'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M59.2,783.5a1.05,1.05,0,0,0,.1.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M59.1,752.9c.15-.72.43-.94,1.19-.86a.9.9,0,0,1,.91.86'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M62.5,750.5c.2,0,.39-.23.64-.3a1.18,1.18,0,0,1,1.06.07.9.9,0,0,1,0,1.53'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M62.5,749.8c.67-.61,1.93-.77,2.2.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.6,751c.26-.82,1.63-1.44,2.1-.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.6,750.3c0-1,1.75-1.5,2.1-.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M57.7,750.7c.28.34,1.8,1.2,2.1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M60.4,751.4c.33.52,2-.32,2.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M60.4,750.7a2.37,2.37,0,0,0,2.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M57.7,749.8c.32.77,1.45.9,2.1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M64.5,738.8a.59.59,0,0,1-.2-.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M64.3,738.3c-.43-.35-.74-.81-1.31-.34a1.86,1.86,0,0,0-.49,1.54'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M57.6,739.5c0-.46-.22-.86-.2-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M57.4,738.2c-.84-.84-1.28-.09-1.7.6'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M53.3,788.9c-.23,0-.1.66-.1.8'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M53.3,789.9c-.15,0-.1,0-.1-.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='28.32' y1='78.92' x2='28.32' y2='78.72' />
      <path d='M48.3,791v-1.1' transform='translate(-19.98 -710.18)' />
      <line x1='28.32' y1='79.62' x2='28.32' y2='80.32' />
      <path d='M53.8,790.3v.7' transform='translate(-19.98 -710.18)' />
      <path
        d='M55.2,784.2c-.38-.37-1,.11-1,.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.6,785.4a7.45,7.45,0,0,0-.4-.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M53.3,791.2c.2.3.1.76.1,1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='44.62' y1='74.12' x2='44.62' y2='75.62' />
      <line x1='44.62' y1='73.42' x2='44.62' y2='74.12' />
      <path d='M64.6,783.5v2.3' transform='translate(-19.98 -710.18)' />
      <path d='M64.5,778.2V791' transform='translate(-19.98 -710.18)' />
      <path d='M62.4,736.5v4.4' transform='translate(-19.98 -710.18)' />
      <path d='M62.2,736.5v4.4' transform='translate(-19.98 -710.18)' />
      <line x1='42.02' y1='27.92' x2='42.02' y2='29.12' />
      <line x1='38.22' y1='27.92' x2='38.22' y2='29.12' />
      <path
        d='M57.8,736.5c0,1.39.1,2.94.1,4.4'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M57.7,736.5v4.4' transform='translate(-19.98 -710.18)' />
      <path d='M63.4,786.3v-3.4' transform='translate(-19.98 -710.18)' />
      <path d='M57,786.3v-3.1' transform='translate(-19.98 -710.18)' />
      <path d='M57,786.2v-3' transform='translate(-19.98 -710.18)' />
      <path d='M56.9,786.3v-3.4' transform='translate(-19.98 -710.18)' />
      <path d='M58.2,806.2v3.9' transform='translate(-19.98 -710.18)' />
      <path d='M65.7,783.6v1.6' transform='translate(-19.98 -710.18)' />
      <path d='M65.7,785.2v-1.7' transform='translate(-19.98 -710.18)' />
      <line x1='35.22' y1='74.22' x2='35.22' y2='74.52' />
      <line x1='34.42' y1='28.12' x2='34.42' y2='29.02' />
      <line x1='35.22' y1='74.22' x2='35.22' y2='73.42' />
      <path d='M63.4,808.1v-.3' transform='translate(-19.98 -710.18)' />
      <path
        d='M56.7,808.1c0-.22.08-.33-.1-.3'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M57.4,807.8v.3' transform='translate(-19.98 -710.18)' />
      <path
        d='M66.1,778.9c-.2-.41-.11-.72-.61-.6a.35.35,0,0,0-.29.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M72.4,776.4v4.5h-.1v-4.5'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='52.42' y1='66.22' x2='52.42' y2='67.92' />
      <path d='M72.4,778.1v2.8' transform='translate(-19.98 -710.18)' />
      <line x1='47.42' y1='66.22' x2='47.42' y2='66.32' />
      <line x1='47.22' y1='68.52' x2='47.22' y2='66.22' />
      <path
        d='M67.4,776.4v3.94c0,.35,0,.86-.2.32a7.24,7.24,0,0,1,0-2'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M67.4,779.6v1.3' transform='translate(-19.98 -710.18)' />
      <path d='M67.4,778.3v-1.8' transform='translate(-19.98 -710.18)' />
      <line x1='47.42' y1='68.82' x2='47.42' y2='70.72' />
      <line x1='46.82' y1='67.92' x2='46.82' y2='69.02' />
      <line x1='30.52' y1='32.62' x2='30.82' y2='32.22' />
      <path
        d='M50.6,750.1c.06-.37.13-.73.2-1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M47.6,750.1c-.06-.37-.13-.73-.2-1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='27.72' y1='40.02' x2='27.62' y2='39.92' />
      <line x1='27.72' y1='32.62' x2='27.42' y2='32.22' />
      <path d='M41.5,729.1V727' transform='translate(-19.98 -710.18)' />
      <line x1='32.62' y1='40.82' x2='34.82' y2='42.32' />
      <path
        d='M52.6,750.8a.1.1,0,0,0,.1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='32.82' y1='39.82' x2='35.02' y2='40.92' />
      <path
        d='M55,752.5c.82-.33.6-.6.2-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='32.62' y1='40.82' x2='34.82' y2='42.32' />
      <line x1='35.02' y1='42.32' x2='35.52' y2='42.12' />
      <line x1='25.42' y1='39.72' x2='23.22' y2='40.82' />
      <path d='M45.6,750.9l.1-.1' transform='translate(-19.98 -710.18)' />
      <line x1='23.32' y1='42.12' x2='25.62' y2='40.72' />
      <path d='M43.2,752.2h.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M43,751.1c-.11.19-.41.56-.4.8,0,.43.17.32.6.4'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M43.2,752.2h.1' transform='translate(-19.98 -710.18)' />
      <line x1='22.72' y1='42.02' x2='23.22' y2='42.12' />
      <path
        d='M52.8,744.9c.2.11.4.12.4.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M52.8,745c.24,0,.52.34.3.4'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='25.32' y1='34.82' x2='25.32' y2='34.72' />
      <line x1='25.12' y1='34.92' x2='25.12' y2='35.12' />
      <path
        d='M51.4,749.3c.2.09-.05.93-.1,1.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='31.32' y1='40.52' x2='31.32' y2='40.32' />
      <path
        d='M52.6,750.8a.1.1,0,0,0,.1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.2,751.2c.18.31.5.62.5,1a5.93,5.93,0,0,1-.7.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.3,751.2a.22.22,0,0,0-.2-.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='32.82' y1='39.72' x2='35.02' y2='40.82' />
      <path d='M51.3,750.7l-.3.1' transform='translate(-19.98 -710.18)' />
      <line x1='32.82' y1='39.82' x2='35.02' y2='40.82' />
      <path
        d='M55.3,751.2a.22.22,0,0,0-.2-.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.2,751.2c.21.36.47.67.4,1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='35.92' y1='44.72' x2='35.92' y2='44.32' />
      <line x1='21.62' y1='39.72' x2='21.62' y2='39.82' />
      <line x1='21.52' y1='39.42' x2='21.52' y2='39.82' />
      <line x1='22.32' y1='39.62' x2='22.32' y2='39.22' />
      <line x1='21.52' y1='40.12' x2='21.52' y2='39.82' />
      <line x1='21.32' y1='40.32' x2='21.32' y2='38.92' />
      <line x1='21.62' y1='39.72' x2='21.62' y2='39.82' />
      <line x1='22.32' y1='39.62' x2='22.32' y2='39.72' />
      <path
        d='M41.7,748.6c-.25.23-.2.49-.2.8'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='21.52' y1='39.22' x2='21.52' y2='39.42' />
      <path d='M42.3,748.6v.3' transform='translate(-19.98 -710.18)' />
      <line x1='22.32' y1='38.42' x2='22.32' y2='38.22' />
      <line x1='22.32' y1='38.22' x2='22.32' y2='37.82' />
      <path
        d='M43.5,746.2c.67-.14,1.1-.77,1.57-1.21s1.28-1,1.93-1.49'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.32' y1='39.82' x2='22.32' y2='39.72' />
      <line x1='27.02' y1='33.32' x2='27.02' y2='33.12' />
      <path
        d='M47.2,743.7c-.33.91-2,1.88-2.7,2.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M51.2,743.3a42.39,42.39,0,0,0,4.3,3.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.5,746.8a1.76,1.76,0,0,0,.3.4'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='31.22' y1='33.02' x2='31.22' y2='33.12' />
      <path
        d='M46.8,749.2c-.2.09.05.93.1,1.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M43.2,750.8a.22.22,0,0,0-.2.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M43,751.1c-.15.26-.58.72-.48,1,0,.1.47.34.57.4'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='23.32' y1='42.12' x2='25.62' y2='40.72' />
      <path d='M45.6,750.9l.1-.1' transform='translate(-19.98 -710.18)' />
      <line x1='26.92' y1='40.22' x2='26.92' y2='40.32' />
      <path
        d='M43,751.1c-.23.39-.62.84-.4,1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M43.2,750.8a.22.22,0,0,0-.2.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='25.42' y1='39.72' x2='23.22' y2='40.82' />
      <line x1='21.52' y1='43.92' x2='21.52' y2='41.92' />
      <path d='M41.5,754.7v-.6' transform='translate(-19.98 -710.18)' />
      <line x1='22.32' y1='44.72' x2='22.32' y2='44.32' />
      <line x1='21.52' y1='41.92' x2='21.52' y2='41.82' />
      <path d='M41.3,753.5v-1.2' transform='translate(-19.98 -710.18)' />
      <line x1='21.52' y1='41.52' x2='21.52' y2='41.82' />
      <line x1='21.32' y1='43.52' x2='21.32' y2='43.32' />
      <line x1='21.32' y1='42.12' x2='21.32' y2='41.92' />
      <line x1='21.32' y1='41.92' x2='21.32' y2='40.32' />
      <line x1='21.32' y1='43.62' x2='21.32' y2='43.52' />
      <path
        d='M41.5,751.4c0-.33-.06-.64.2-.9'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.32' y1='40.92' x2='22.32' y2='40.52' />
      <line x1='21.52' y1='41.22' x2='21.52' y2='41.42' />
      <line x1='22.32' y1='40.52' x2='22.32' y2='40.22' />
      <line x1='21.52' y1='40.52' x2='21.52' y2='40.12' />
      <line x1='22.32' y1='40.22' x2='22.32' y2='39.82' />
      <path d='M41.5,751v-.3' transform='translate(-19.98 -710.18)' />
      <line x1='21.52' y1='39.82' x2='21.52' y2='39.92' />
      <line x1='26.92' y1='40.32' x2='27.62' y2='39.92' />
      <line x1='27.42' y1='38.82' x2='26.72' y2='39.12' />
      <line x1='27.22' y1='40.52' x2='27.82' y2='40.12' />
      <line x1='27.02' y1='33.12' x2='27.72' y2='32.62' />
      <line x1='26.82' y1='32.72' x2='27.42' y2='32.22' />
      <line x1='31.42' y1='39.12' x2='30.82' y2='38.82' />
      <line x1='30.62' y1='39.92' x2='31.32' y2='40.32' />
      <line x1='30.82' y1='32.22' x2='31.42' y2='32.72' />
      <line x1='30.52' y1='32.62' x2='31.22' y2='33.12' />
      <line x1='31.02' y1='33.52' x2='30.52' y2='33.12' />
      <line x1='32.52' y1='22.12' x2='29.62' y2='20.52' />
      <path
        d='M56,734.2c.24.17.61.34.7.6'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.4,725.8c1.45.73,2.81,1.65,4.2,2.5'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='32.52' y1='22.12' x2='36.02' y2='24.02' />
      <line x1='36.72' y1='24.52' x2='36.82' y2='24.12' />
      <line x1='36.72' y1='24.62' x2='36.82' y2='24.32' />
      <path
        d='M56.8,734.3c-.27-.12-.68-.47-.8-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.4,725.8c.12-.37.53,0,.8.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M56.7,734.8a.19.19,0,0,1,.1.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='21.52' y1='16.82' x2='21.42' y2='16.62' />
      <path
        d='M40.6,735.1c-.28.6-.56,1.19-.8,1.8'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='20.62' y1='24.12' x2='19.82' y2='25.92' />
      <line x1='19.82' y1='26.22' x2='20.02' y2='26.22' />
      <line x1='21.12' y1='14.72' x2='21.12' y2='19.02' />
      <line x1='21.42' y1='14.72' x2='21.42' y2='18.92' />
      <path d='M41.1,724.8v-.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M41.4,724.8a.37.37,0,0,0-.1-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='19.82' y1='11.22' x2='21.12' y2='14.52' />
      <line x1='19.82' y1='10.42' x2='21.32' y2='14.42' />
      <path
        d='M62.5,743.9c-.23.64-.45,1.27-.7,1.9'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='42.52' y1='32.92' x2='41.82' y2='34.82' />
      <line x1='41.82' y1='34.92' x2='42.02' y2='35.12' />
      <line x1='43.32' y1='23.52' x2='43.32' y2='27.62' />
      <line x1='43.02' y1='23.52' x2='43.02' y2='27.72' />
      <path d='M63,733.6v-.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M63.3,733.6a.37.37,0,0,0-.1-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='41.82' y1='19.32' x2='43.22' y2='23.12' />
      <line x1='41.82' y1='20.12' x2='43.02' y2='23.22' />
      <path d='M36.4,736.5l-.2-.1.2.8' transform='translate(-19.98 -710.18)' />
      <path
        d='M35.7,734.3c.13.37.92,2,.5,2.1l-.5-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M35.4,724.6v.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M35,724.5c0,.1-.1.2-.1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='15.22' y1='19.02' x2='15.22' y2='14.72' />
      <line x1='14.92' y1='18.92' x2='14.92' y2='14.72' />
      <line x1='15.02' y1='14.42' x2='16.32' y2='10.82' />
      <line x1='15.22' y1='14.52' x2='16.32' y2='11.52' />
      <path d='M58.4,745.4l-.2-.1.2.6' transform='translate(-19.98 -710.18)' />
      <path
        d='M57.6,743.2c.16.37,1.14,1.76.6,2.1l-.6-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='37.12' y1='27.72' x2='37.12' y2='23.52' />
      <line x1='36.82' y1='27.62' x2='36.82' y2='23.52' />
      <path d='M57.3,733.4v.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M57,733.3c0,.1-.1.2-.1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='36.92' y1='23.12' x2='38.32' y2='19.52' />
      <line x1='37.12' y1='23.22' x2='38.32' y2='20.32' />
      <line x1='32.52' y1='28.42' x2='35.72' y2='30.32' />
      <line x1='22.52' y1='22.72' x2='25.62' y2='24.42' />
      <path
        d='M46.1,734.9c-.2-.1-.3-.2-.5-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='30.52' y1='27.32' x2='32.12' y2='28.22' />
      <line x1='26.02' y1='24.72' x2='27.72' y2='25.62' />
      <path
        d='M52.6,738.5c-.1-.1-.3-.2-.4-.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='36.52' y1='26.22' x2='36.52' y2='27.62' />
      <path
        d='M56.7,735.8a.76.76,0,0,0-.2.5'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='36.82' y1='25.52' x2='36.62' y2='25.72' />
      <path
        d='M41.7,727.5c0-.2-.1-.3-.2-.5'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='21.72' y1='18.92' x2='21.72' y2='17.42' />
      <path
        d='M46.7,729.6a.3.3,0,0,1,0,.6A.3.3,0,0,1,46.7,729.6Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M51.6,736.3a.3.3,0,0,1,0,.6A.3.3,0,0,1,51.6,736.3Z'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='26.12' y1='18.12' x2='32.22' y2='21.62' />
      <path d='M45.7,728c.1.1.3.2.4.3' transform='translate(-19.98 -710.18)' />
      <path
        d='M52.2,731.7c.2.1.3.2.5.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.7,728l-2-1.2c-.31-.18-1.44-1.17-1.7-.7'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='32.62' y1='21.92' x2='36.12' y2='23.82' />
      <path
        d='M52.1,731.9c.2.1.3.2.5.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='26.02' y1='18.32' x2='32.12' y2='21.82' />
      <path
        d='M45.6,728.3c.1.1.3.2.4.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='30.52' y1='25.32' x2='32.52' y2='24.12' />
      <path
        d='M52.6,734.3a1.14,1.14,0,0,0,0-2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M49.7,730.6a1.27,1.27,0,0,0-1.2,0'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='28.52' y1='20.52' x2='25.72' y2='22.12' />
      <path
        d='M45.7,732.3a1.14,1.14,0,0,0,0,2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='25.72' y1='24.12' x2='27.72' y2='25.32' />
      <path d='M53.2,745.3l-.3-.3' transform='translate(-19.98 -710.18)' />
      <line x1='35.22' y1='37.32' x2='33.82' y2='36.12' />
      <line x1='30.42' y1='40.12' x2='31.12' y2='40.62' />
      <path
        d='M50.6,750a5.16,5.16,0,0,0,.2-1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.32' y1='38.12' x2='22.52' y2='37.82' />
      <path d='M45.4,745l-.3.3' transform='translate(-19.98 -710.18)' />
      <line x1='27.72' y1='33.12' x2='24.42' y2='36.02' />
      <path
        d='M47.4,748.9a4.25,4.25,0,0,0,.2,1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.4,732.8a1.41,1.41,0,0,0-2.6,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.5,749.8a1.4,1.4,0,1,0-2.8,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.2,750.6a1.24,1.24,0,0,0,.1-1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M48,748.9a1.24,1.24,0,0,0,.1,1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M48,749.9c0,1.3,2.2,1.29,2.2,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M48.5,749c.69-.76,2.25.35,1.7,1.4C49.33,752.08,46.71,749.9,48.5,749Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M49.3,748.9c-1.38,0-1.78,1.85-.33,2a1,1,0,0,0,1.16-.79C50.36,749.32,49.76,749.3,49.3,748.9Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M49.2,750.9a1.29,1.29,0,0,0,1.2-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M48,750a1.2,1.2,0,0,0,1.2.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M42.4,749.9h0' transform='translate(-19.98 -710.18)' />
      <path d='M42.4,749.9h0' transform='translate(-19.98 -710.18)' />
      <path
        d='M41.9,751.1a.22.22,0,0,0-.2.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='21.52' y1='40.22' x2='21.42' y2='40.22' />
      <path d='M42,751.2h0' transform='translate(-19.98 -710.18)' />
      <path
        d='M42.3,751.1a.37.37,0,0,0-.1.3'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='23.22' y1='40.72' x2='25.42' y2='39.72' />
      <path
        d='M45.8,750.7a2.77,2.77,0,0,0-.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M43.2,752.3h.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M51,743.7c1.29,1.33,2.76,2.52,4.1,3.8'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.32' y1='38.22' x2='22.42' y2='38.22' />
      <path
        d='M42.3,748.7a3.24,3.24,0,0,1,.3-.7'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='21.52' y1='37.82' x2='21.52' y2='38.52' />
      <line x1='21.52' y1='38.92' x2='21.52' y2='38.72' />
      <path
        d='M41.8,748.6c-.1,0-.2,0-.2.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M42.3,749.2c0-.22.15-.69-.2-.6'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M42.3,749.1v.3' transform='translate(-19.98 -710.18)' />
      <path
        d='M42.3,749.8c.1,0,.1,0,.1-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M56.9,752.6v1.2' transform='translate(-19.98 -710.18)' />
      <path d='M56.7,754.7v-2.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M54.9,752.4a.19.19,0,0,0,.3,0'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='34.82' y1='42.32' x2='32.62' y2='40.82' />
      <path
        d='M52.8,749.9a1.41,1.41,0,0,0-.1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M52.9,745.4a.27.27,0,0,1-.1-.3h.1C53,745.25,53,745.37,52.9,745.4Z'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='22.42' y1='39.92' x2='22.42' y2='40.22' />
      <path
        d='M45.2,745.5c0-.36.15-.09.2-.4C45.44,745.29,45.28,745.41,45.2,745.5Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.4,744.9c-.1,0-.2.1-.3.2'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='25.12' y1='35.22' x2='25.02' y2='35.22' />
      <path
        d='M45.2,745a.71.71,0,0,0-.2.3.38.38,0,0,1,.4-.3Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.7,750.8a2.77,2.77,0,0,0-.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='23.42' y1='42.12' x2='25.62' y2='40.72' />
      <path
        d='M43.3,750.9c-.1,0-.1.1-.2.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.7,750.7a2.77,2.77,0,0,0-.1-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M54.8,752.3H55' transform='translate(-19.98 -710.18)' />
      <path
        d='M52.7,750a1.41,1.41,0,0,0-.1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M55,752.3h.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M55.2,751.2c0-.1-.1-.1-.2-.2'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M52.7,749.9a1.41,1.41,0,0,0-.1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M52,732.5a.8.8,0,0,1,0,1.6A.8.8,0,0,1,52,732.5Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M46.3,732.5a.8.8,0,0,1,0,1.6A.8.8,0,0,1,46.3,732.5Z'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='36.72' y1='25.72' x2='36.72' y2='27.62' />
      <path
        d='M47.8,742.3a.37.37,0,0,0-.3.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M47.8,748.9a.37.37,0,0,0-.3.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M47.7,750h0' transform='translate(-19.98 -710.18)' />
      <line x1='30.52' y1='40.02' x2='30.62' y2='39.92' />
      <path
        d='M50.7,750.1c-.1,0-.1-.1,0,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.9,748.9c-.1,0-.2-.1-.3-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M50.9,742.4a.37.37,0,0,0-.3-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M67.5,779.5c-.1,0-.1,0-.1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='52.12' y1='69.32' x2='47.52' y2='69.32' />
      <path d='M72.3,779.5l-.1-.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M67.5,776.2c-.1,0-.1,0-.2.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='52.12' y1='66.02' x2='47.52' y2='66.12' />
      <path
        d='M72.3,776.3c0-.1-.1-.1-.2-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M67.4,780.9c0,.1.1.1.2.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='52.42' y1='67.92' x2='52.42' y2='68.92' />
      <line x1='52.12' y1='70.82' x2='47.52' y2='70.82' />
      <path
        d='M72.2,780.9c.1,0,.1,0,.2-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M67.4,777.7l.1.1' transform='translate(-19.98 -710.18)' />
      <line x1='52.12' y1='67.72' x2='47.52' y2='67.72' />
      <path
        d='M72.2,777.8c.1,0,.1,0,.1-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M67.4,778.2v.8' transform='translate(-19.98 -710.18)' />
      <path d='M55.3,783.4h0' transform='translate(-19.98 -710.18)' />
      <path d='M56.1,807.7v.8' transform='translate(-19.98 -710.18)' />
      <path d='M64.7,808.5v0Z' transform='translate(-19.98 -710.18)' />
      <path
        d='M65.7,784.1c.92,0,.86,1.1,0,1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M56.7,808.1h.6' transform='translate(-19.98 -710.18)' />
      <path d='M64.1,807.7v.4' transform='translate(-19.98 -710.18)' />
      <path d='M63.5,808.1h.6' transform='translate(-19.98 -710.18)' />
      <path d='M65.7,739.1v0Z' transform='translate(-19.98 -710.18)' />
      <path d='M56.4,785.8v0Z' transform='translate(-19.98 -710.18)' />
      <path d='M65.7,783.5h0' transform='translate(-19.98 -710.18)' />
      <path d='M57.8,807.7v.8' transform='translate(-19.98 -710.18)' />
      <path d='M62.7,806.2v3.9' transform='translate(-19.98 -710.18)' />
      <path d='M63,807.7v.8' transform='translate(-19.98 -710.18)' />
      <path d='M59.2,786.2q0-.13.1-.1' transform='translate(-19.98 -710.18)' />
      <line x1='41.22' y1='75.92' x2='41.42' y2='75.92' />
      <path d='M57.1,786.3v-.2' transform='translate(-19.98 -710.18)' />
      <path d='M63.7,786.3v0Z' transform='translate(-19.98 -710.18)' />
      <path d='M64.7,783.4h0' transform='translate(-19.98 -710.18)' />
      <path
        d='M54.9,790.3v.6c0-.31.13-.71-.3-.6a.23.23,0,0,0,.3-.2c.16.37.51.16.33.63-.1.25-.3.43-.53.17'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='28.02' y1='79.92' x2='28.02' y2='81.02' />
      <path d='M53.4,791h0' transform='translate(-19.98 -710.18)' />
      <path d='M53.8,790.2v.7' transform='translate(-19.98 -710.18)' />
      <path
        d='M48,789.9c0,.42-.1,2.43.3,2.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M53.2,789.9c0,.4-.17,2.47.2,2.4l-.1-1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M48.4,790.2v.8' transform='translate(-19.98 -710.18)' />
      <path
        d='M48,789.9c0-.22-.09-.89,0-1S48.64,790,48,789.9Z'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M53.3,791v0Z' transform='translate(-19.98 -710.18)' />
      <path d='M60.4,750.6h-.5' transform='translate(-19.98 -710.18)' />
      <path d='M60.4,751.4h-.5' transform='translate(-19.98 -710.18)' />
      <path
        d='M56.8,752.4c.6.4,1.3.9,1.9,1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.6,753.7c.9-.6,1.8-1.2,2.7-1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M58.6,753.9a1.55,1.55,0,0,1,1.72-1.28c.79.07.92.69,1.28,1.28'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M58.8,754.6c-.68-.84.42-1.89,1.27-1.92s1.82.94,1.33,1.82'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.2,759.3c.81-.65.08-1.24-.1-1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M59.2,757.4a1.25,1.25,0,0,0-.1,1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.6,758.3a1.05,1.05,0,0,0-.5-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M59.1,757.3a1.23,1.23,0,0,0-.5,1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M60.2,759.3c-.3.18-.56.1-.82.37a.89.89,0,0,0-.17.87,1,1,0,0,0,1.43.55A.83.83,0,0,0,61,759.8C60.78,759.46,60.44,759.53,60.2,759.3Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.3,758.4a.6.6,0,0,0-.1-.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M59.3,758a.6.6,0,0,0-.1.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M64,798.1a3.55,3.55,0,0,0-.2-1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M58.4,795.6a4.57,4.57,0,0,0-1.4,1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M63.8,797.2a3.91,3.91,0,0,0-1.4-1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.1,790a.71.71,0,0,0-1.4,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M60.4,799.3a2,2,0,0,0,3.6-1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M60.3,799.4v-3.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M59.7,756.4a1.1,1.1,0,0,0,.8,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M42.4,758.2v.1a2.61,2.61,0,0,0-.3-1.6A2.32,2.32,0,0,0,42.4,758.2Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M78.2,757.1c-.21.16-.12.53-.19.74s-.21,0-.21.36a2.61,2.61,0,0,1,.4-1.7Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.6,770.7c-.1,0-.1,0-.1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='30.22' y1='60.52' x2='25.62' y2='60.52' />
      <path d='M50.3,770.6l-.1-.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M45.6,767.4c-.1,0-.1,0-.2.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='30.22' y1='57.22' x2='25.62' y2='57.22' />
      <path
        d='M50.4,767.5c0-.1-.1-.1-.2-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M45.6,772.1c0,.1.1.1.2.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='30.32' y1='62.12' x2='25.72' y2='62.12' />
      <path
        d='M50.3,772.1c.1,0,.1,0,.2-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M45,769.3v1.1' transform='translate(-19.98 -710.18)' />
      <path d='M45.5,768.9l.1.1' transform='translate(-19.98 -710.18)' />
      <line x1='30.22' y1='58.92' x2='25.62' y2='58.92' />
      <path
        d='M50.2,769c.1,0,.1,0,.1-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M45.4,769.5v.8' transform='translate(-19.98 -710.18)' />
      <path
        d='M50.6,772.1c-.39.06-.2-1.91-.2-2.25s-.19-2.14.1-2.25'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M33.4,774.6h0' transform='translate(-19.98 -710.18)' />
      <path d='M34.2,799v.8' transform='translate(-19.98 -710.18)' />
      <path d='M42.7,799.7v0Z' transform='translate(-19.98 -710.18)' />
      <path
        d='M43.8,775.2c.73.14.85,1.2,0,1.2'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M35.4,799v.4' transform='translate(-19.98 -710.18)' />
      <path d='M34.8,799.3h.6' transform='translate(-19.98 -710.18)' />
      <path d='M42.2,798.9v.5' transform='translate(-19.98 -710.18)' />
      <path d='M41.6,799.4h.6' transform='translate(-19.98 -710.18)' />
      <path d='M32.5,729.4v.9' transform='translate(-19.98 -710.18)' />
      <path d='M43.8,730.3v0Z' transform='translate(-19.98 -710.18)' />
      <path d='M34.5,775.4v.9' transform='translate(-19.98 -710.18)' />
      <path d='M43.9,774.6h0' transform='translate(-19.98 -710.18)' />
      <path d='M36,799v.8' transform='translate(-19.98 -710.18)' />
      <path d='M41.1,799v.8' transform='translate(-19.98 -710.18)' />
      <path d='M35.2,777.4v-.1' transform='translate(-19.98 -710.18)' />
      <path d='M41.7,775.3v.9' transform='translate(-19.98 -710.18)' />
      <path d='M42.7,774.6h0' transform='translate(-19.98 -710.18)' />
      <path
        d='M33,781.5v.7c0-.39.14-.84-.4-.7.29-.11.59-.15.74.17.26.54-.36.53-.64.53'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M26.2,781.3v1' transform='translate(-19.98 -710.18)' />
      <path d='M31.5,782.2h0' transform='translate(-19.98 -710.18)' />
      <path d='M31.8,781.3v.8' transform='translate(-19.98 -710.18)' />
      <path
        d='M26.2,781.1c0,.39-.18,2.31.1,2.4'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M26.4,781.4v.8' transform='translate(-19.98 -710.18)' />
      <path
        d='M26.2,781.1l-.1-1C26.49,780,26.3,781.05,26.2,781.1Z'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M31.5,781.2v1' transform='translate(-19.98 -710.18)' />
      <path d='M38.4,741.8h-.5' transform='translate(-19.98 -710.18)' />
      <path d='M38.4,742.6h-.5' transform='translate(-19.98 -710.18)' />
      <path
        d='M34,743a21.11,21.11,0,0,0,2.7,1.8'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.7,744.8c.9-.6,1.8-1.2,2.7-1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M36.9,745.7c-.75-.85.55-1.93,1.38-1.83s1.79,1,1.22,1.83'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.3,750.5c.24-.57.73-1.54-.2-1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M37.3,748.6a1.24,1.24,0,0,0-.1,1.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.7,749.4a1.05,1.05,0,0,0-.5-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M37.2,748.4a1.23,1.23,0,0,0-.5,1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M38,750.5c-.16.5-1,.4-.9,1.12.08.44.59.65,1,.68C39.58,752.4,39.42,750.5,38,750.5Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.2,749.6a.6.6,0,0,0-.1-.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M37.3,749.2a.6.6,0,0,0-.1.4'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M35.1,788.4a1.88,1.88,0,0,0-.2.8'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M36.5,786.7a4.57,4.57,0,0,0-1.4,1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.8,788.4a3.91,3.91,0,0,0-1.4-1.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.1,781.3a.71.71,0,0,0-1.4,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M34.9,789.3a2,2,0,0,0,3.6,1.3'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M38.4,790.6v-3.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M37.8,747.7a1.1,1.1,0,0,0,.8,0'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M20.5,749.4v.1a9.84,9.84,0,0,0-.4-1.7A3.93,3.93,0,0,0,20.5,749.4Z'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M55.8,749.3c.24-.08.11-1.27.4-1.6A2.44,2.44,0,0,1,55.8,749.3Z'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='30.52' y1='32.12' x2='30.52' y2='23.22' />
      <line x1='30.52' y1='38.82' x2='30.52' y2='38.02' />
      <line x1='30.52' y1='39.32' x2='30.52' y2='39.22' />
      <line x1='27.72' y1='39.22' x2='27.72' y2='39.32' />
      <line x1='27.72' y1='37.32' x2='27.72' y2='38.82' />
      <line x1='27.72' y1='23.22' x2='27.72' y2='32.12' />
      <path
        d='M48,750.7a1.72,1.72,0,0,0,2.2,0'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='21.82' y1='45.02' x2='22.12' y2='45.02' />
      <path
        d='M42.1,755a.19.19,0,0,0,.2-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M41.5,754.6a.47.47,0,0,0,.5.5'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M46.3,749.1h0' transform='translate(-19.98 -710.18)' />
      <path d='M52.2,743l-.1-.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M55.8,746a7.75,7.75,0,0,1-1.8-1.38c-.62-.52-1.27-1-1.9-1.52'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M42.3,748.6c.12-.22.12-.53.4-.6'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M46.2,742.9a.1.1,0,0,0-.1.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M46.1,743.1a20.63,20.63,0,0,0-3.8,3.2'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M55.9,754.9h0' transform='translate(-19.98 -710.18)' />
      <path
        d='M56.6,755a.52.52,0,0,0,.2-.4'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M52.1,749.2h0' transform='translate(-19.98 -710.18)' />
      <path d='M53,745.4q.13,0,.1-.1' transform='translate(-19.98 -710.18)' />
      <line x1='32.92' y1='34.82' x2='32.82' y2='34.92' />
      <path
        d='M42.5,750a.14.14,0,0,0-.2,0'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M42.3,750.4h.2' transform='translate(-19.98 -710.18)' />
      <path
        d='M45.4,745.3a.26.26,0,0,0-.1-.3l-.1.1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='46.82' y1='68.12' x2='45.92' y2='68.12' />
      <line x1='46.12' y1='68.82' x2='46.82' y2='68.82' />
      <path
        d='M72.5,779.1a.91.91,0,0,0,0-1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='36.42' y1='73.32' x2='35.22' y2='73.32' />
      <line x1='36.42' y1='74.92' x2='36.92' y2='74.92' />
      <line x1='36.92' y1='74.02' x2='36.42' y2='74.02' />
      <line x1='44.52' y1='74.02' x2='43.72' y2='74.02' />
      <line x1='43.72' y1='74.92' x2='44.52' y2='74.92' />
      <line x1='37.02' y1='89.22' x2='36.62' y2='97.62' />
      <line x1='37.42' y1='97.62' x2='37.82' y2='89.82' />
      <line x1='44.52' y1='28.92' x2='45.72' y2='28.92' />
      <line x1='45.72' y1='28.02' x2='44.22' y2='28.02' />
      <line x1='35.52' y1='75.62' x2='36.42' y2='75.62' />
      <line x1='43.42' y1='73.02' x2='41.42' y2='73.02' />
      <line x1='37.92' y1='30.72' x2='38.22' y2='29.12' />
      <line x1='42.02' y1='29.12' x2='42.22' y2='30.72' />
      <line x1='42.22' y1='26.32' x2='42.02' y2='27.92' />
      <line x1='42.42' y1='30.72' x2='42.52' y2='30.22' />
      <path
        d='M48.3,792.2c.37.5,1.91.1,2.45.1s2.08.4,2.45-.1'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M48.2,790a.91.91,0,0,0,0,1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='33.82' y1='79.82' x2='33.32' y2='79.82' />
      <line x1='35.82' y1='39.12' x2='35.82' y2='39.62' />
      <line x1='39.22' y1='50.52' x2='39.42' y2='80.72' />
      <line x1='38.82' y1='46.52' x2='38.82' y2='47.52' />
      <line x1='41.42' y1='47.52' x2='41.42' y2='46.52' />
      <line x1='41.62' y1='48.22' x2='41.62' y2='48.12' />
      <line x1='41.22' y1='50.12' x2='41.22' y2='48.22' />
      <line x1='39.12' y1='48.22' x2='39.12' y2='50.12' />
      <line x1='24.92' y1='59.42' x2='24.02' y2='59.42' />
      <line x1='24.22' y1='60.02' x2='24.92' y2='60.02' />
      <path
        d='M50.6,770.3a.91.91,0,0,0,0-1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='25.22' y1='59.12' x2='24.92' y2='59.12' />
      <line x1='24.92' y1='60.32' x2='25.22' y2='60.32' />
      <line x1='14.42' y1='64.52' x2='13.32' y2='64.52' />
      <line x1='15.12' y1='80.42' x2='14.82' y2='88.82' />
      <line x1='21.12' y1='81.02' x2='21.52' y2='88.72' />
      <line x1='12.52' y1='20.12' x2='13.72' y2='20.12' />
      <line x1='14.02' y1='19.32' x2='12.52' y2='19.32' />
      <line x1='22.42' y1='20.12' x2='23.82' y2='20.12' />
      <line x1='23.82' y1='19.22' x2='22.32' y2='19.22' />
      <line x1='13.62' y1='66.82' x2='14.42' y2='66.82' />
      <line x1='22.62' y1='66.82' x2='23.82' y2='66.82' />
      <line x1='21.52' y1='64.12' x2='19.52' y2='64.12' />
      <line x1='15.72' y1='21.32' x2='15.82' y2='21.92' />
      <line x1='16.02' y1='21.92' x2='16.22' y2='20.32' />
      <line x1='20.02' y1='20.32' x2='20.32' y2='21.82' />
      <line x1='20.52' y1='21.82' x2='20.62' y2='21.32' />
      <path
        d='M26.3,783.4c.41.43,1.57.15,2.07.12a9.3,9.3,0,0,0,2.93-.12'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M26.2,781.3a.91.91,0,0,0,0,1'
        transform='translate(-19.98 -710.18)'
      />
      <line x1='6.12' y1='72.22' x2='6.22' y2='72.22' />
      <line x1='6.22' y1='71.22' x2='6.12' y2='71.22' />
      <path d='M31,781.7h.3' transform='translate(-19.98 -710.18)' />
      <line x1='19.32' y1='72.02' x2='19.12' y2='41.62' />
      <line x1='17.22' y1='41.72' x2='17.52' y2='72.02' />
      <line x1='16.92' y1='37.82' x2='16.92' y2='38.82' />
      <line x1='19.52' y1='38.82' x2='19.52' y2='37.82' />
      <line x1='19.72' y1='39.42' x2='19.72' y2='39.32' />
      <line x1='16.72' y1='39.32' x2='16.72' y2='39.42' />
      <line x1='19.32' y1='41.22' x2='19.32' y2='39.42' />
      <line x1='17.12' y1='39.42' x2='17.12' y2='41.22' />
      <line x1='14.82' y1='79.02' x2='14.82' y2='79.22' />
      <path
        d='M39.8,741.5c0-9.83-.1-19.67-.1-29.5'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M39.5,748.9a4,4,0,0,0,.4-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M36.6,748a1.42,1.42,0,0,0,.3.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M36.4,744.7v1.6' transform='translate(-19.98 -710.18)' />
      <path
        d='M61.8,750.4c0-9.9-.2-19.8-.2-29.7'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M61.4,757.6c.44-.16.34-.56.5-.9'
        transform='translate(-19.98 -710.18)'
      />
      <path
        d='M58.5,756.7a2.63,2.63,0,0,0,.3.9'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M58.4,753.6V755' transform='translate(-19.98 -710.18)' />
      <path d='M40,785.6v-4.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M40.2,785.8c0-1.23-.19-2.45-.2-3.68,0-.75.11-1.73-.7-2.12'
        transform='translate(-19.98 -710.18)'
      />
      <path d='M62,794.4v-4.1' transform='translate(-19.98 -710.18)' />
      <path
        d='M62,794.5c0-1.22,0-2.45,0-3.67,0-.76,0-1.64-.8-2'
        transform='translate(-19.98 -710.18)'
      />
    </g>
  );
};
const VARSITY = (rotate = 0, m) => {
  return (
    <g
      transform={`rotate(${rotate})`}
      style={{
        strokeWidth: 0.24,
        stroke: 'black',
        fill: 'none',
        fillOpacity: 0
      }}
    >
      <image
        xlinkHref={varsityImage}
        x='0'
        y='0'
        height={2 * m * (rotate === 0 ? VARSITY_DEPTH : VARSITY_WIDTH) + 'px'}
        width={m * (rotate === 0 ? VARSITY_DEPTH : VARSITY_WIDTH) + 'px'}
      />
    </g>
  );
};
const VERTICAL = (rotate = 0, m) => {
  return (
    <g
      transform={`rotate(${rotate})`}
      style={{
        strokeWidth: 0.24,
        stroke: 'black',
        fill: 'none',
        fillOpacity: 0
      }}
    >
      <image
        xlinkHref={verticalImage}
        x='0'
        y='0'
        height={
          1.2 * m * (rotate === 0 ? VERTICAL_DEPTH : VERTICAL_WIDTH) + 'px'
        }
        width={m * (rotate === 0 ? VERTICAL_DEPTH : VERTICAL_WIDTH) + 'px'}
      />
    </g>
  );
};
const VERTICAL_SVG = (rotate = 0) => {
  return (
    <g
      transform={`rotate(${rotate})`}
      style={{
        strokeWidth: 0.24,
        stroke: 'black',
        fill: 'none',
        fillOpacity: 0
      }}
    >
      <path d='M651.3,418.63v-.25h-.2' transform='translate(-621.88 -400.65)' />
      <path d='M654.55,443.58l.35.45' transform='translate(-621.88 -400.65)' />
      <path
        d='M622.1,463c0-.53,0-1,0-1.55l0-.05v0l0,0c0,.54,0,1.06,0,1.6l6.77-.45c1.5-.1,3-.1,4.08-1.35.51-.6.67-1.36,1.23-1.93a3.39,3.39,0,0,1,2.28-1c1.79-.09,3.44.22,5.2.3,1.37.06,3.27.21,4.5-.45v-1.8H639v1.8l.25.15'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M649,443c.24-.81,2.62-1.21,3.35-1.45'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M644.25,422.17h.55v-3.75h-.55'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M644,443.77l-.15.3' transform='translate(-621.88 -400.65)' />
      <path
        d='M652.7,451.38c-.28.14-.54.21-.7.5a.71.71,0,0,0,.35.75h.05'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M657.15,420.13a.86.86,0,0,0-.25-.35h-1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.45,439.38v3.7c0,.53-.29,1.93.2,2.35'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M643.5,450.42V439.48' transform='translate(-621.88 -400.65)' />
      <path d='M637.2,420.73H637v-.15' transform='translate(-621.88 -400.65)' />
      <path
        d='M644,451.92a.28.28,0,0,1,0-.2,1.22,1.22,0,0,0-.7-.4'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M639.5,420.67c0,.47-.53.39-.65,0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M640.9,422.17h-.6v-3.75l-.25,1.5'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M644.8,422.17a8,8,0,0,0,0-3.75'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M652.7,451.83h0a.33.33,0,0,0-.2.25l0,0v3.35'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.9,451.42v-7.15c0-.31,0-.57-.2-.8'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M649.2,421.92H648v-2.7l.4-.05,0,0h.7'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M648,420.83a.82.82,0,0,1-.65-.2v-.2a1,1,0,0,1,.65-.25'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M649.2,420.88v6h.1v-6' transform='translate(-621.88 -400.65)' />
      <path d='M653.45,456.63v2.25' transform='translate(-621.88 -400.65)' />
      <path
        d='M650.9,420.88v-.75h-1.75v.75Z'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M638.3,421.67h-1.1V419a8.64,8.64,0,0,1,1.1-.1'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M643.55,401.08h4' transform='translate(-621.88 -400.65)' />
      <path d='M641.65,439.48v10.95' transform='translate(-621.88 -400.65)' />
      <path
        d='M644.75,418.42v-.3h.15l.15.65'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M640.4,418.42v-.3h-.15l-.15.65'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M673.9,463.23c-2.74-.17-5.51-.23-8.24-.5a3.85,3.85,0,0,1-2.61-1.25c-.77-.89-.9-2-2-2.56s-2.84-.39-4.2-.39l.15,0a.36.36,0,0,1,.1-.15v-1.7h-7.2v1.7c.43.73,2.52.51,3.29.55a8.27,8.27,0,0,0,3.66-.35'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M646.9,441l.15.2v1.6' transform='translate(-621.88 -400.65)' />
      <path
        d='M641.8,451.33c-.54.16-1.07.79-.25,1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M637.2,420.63a.89.89,0,0,1-.7-.3c.06-.32.43-.36.7-.35'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M646.25,419.92l.25-.1' transform='translate(-621.88 -400.65)' />
      <path
        d='M651.3,422.38v.3h-.2V422h-.85'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M674,462.77a11.84,11.84,0,0,0,0-1.2c.05.55-.14,1.1-.1,1.65A1,1,0,0,1,674,462.77Z'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M652,444l.3-.45' transform='translate(-621.88 -400.65)' />
      <path
        d='M645.1,420.67h1.75v-.75H645.1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M652.3,442.83c-.88,0-2.65,1.5-3.35.25v-1.65a.48.48,0,0,1,.2-.2'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.9,452.13a.78.78,0,0,0-.7-.55'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M651.35,408.73l.4.6' transform='translate(-621.88 -400.65)' />
      <path
        d='M643.6,452.38c.2-.07.38-.19.4-.4l0-.05v-.2l0-.05c0-.29-.42-.49-.7-.5'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M646.55,405.42h-.1l0,0h-.05l0,0h0l-2,3'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M655.9,421.27h1a.93.93,0,0,0,.25-.4'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M642.55,456.38v2.25' transform='translate(-621.88 -400.65)' />
      <path
        d='M652.7,455.13h0l-.2.2a.25.25,0,0,1,0,.15l0,0a.33.33,0,0,0,.2.25h0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M647.6,409.92a.73.73,0,0,1,.45-.2.47.47,0,0,0,.3,0,.36.36,0,0,0,.15.1v0l0,.05.15,9.15'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M650.4,420.88a.91.91,0,0,1-.25.4H650v.9h.2v-.9'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M649.3,420.13v-6h-.1v6' transform='translate(-621.88 -400.65)' />
      <path
        d='M654.4,439.73v10.95l-.05.05h0l-.1.1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M645,419.52h.9v-.9h-.2v.9'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M640.1,419.52h-.9v-.9h.2v.9'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M651.75,422.38h-.55v-3.75h.55'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M647.6,421.67V433.6c0,.41-.09.95.4,1.1s.71-.32.75-.72c.15-1.48,0-3,0-4.52v-7.53'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M640.9,407.88l-.1-.1v0h0l0-.05h-.15l-.35.3v.25h0l.65.8'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.6,455.23v-3.4a.53.53,0,0,0-.3-.25'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.25,444.08c-.31-.24-.07-.56.2-.7'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M663,463v0l0-.05c0-.48,0-.93,0-1.4A6.29,6.29,0,0,1,663,463Z'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M649.85,456.77l-3.7-.15'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.7,439.77a14.21,14.21,0,0,1,3.2,1.2v-19.3'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M639.4,418.77h.85v-.65' transform='translate(-621.88 -400.65)' />
      <path
        d='M652.7,450.83l-.2-.15V439.73'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M640.4,422.17v.25h-.15v-.65h-.85'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M646.9,405.88v-.2l-.15-.15a.25.25,0,0,1-.15,0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M651.75,408l-1.65-2.5h-.2l-.05,0a.51.51,0,0,0-.4.3v0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M647.4,420.52c.1-5.06.2-10.11.2-15.17v-4.23a.76.76,0,0,1,1.1,0v0l0,0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M638,442.77a5.85,5.85,0,0,1,0-1.65l.15-.15v-19.3'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M633,463.23c2.74-.17,5.51-.23,8.24-.5a3.69,3.69,0,0,0,2.68-1.4c.69-.88.9-1.91,2-2.41,1.29-.59,2.78-.39,4.17-.39'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.8,451.17c-.37.05-.77.34-.7.75'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.3,455.58a.46.46,0,0,0,.3-.45,1.57,1.57,0,0,0-.3-.25'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M655.15,409.48a10.16,10.16,0,0,0,1-1.25v-.1l0,0a.57.57,0,0,0-.25-.3h-.3c-.16.18-.3.37-.45.55'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.5,455.48v-3.35l0,0a.33.33,0,0,0-.2-.25h0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M652.7,451.58a.78.78,0,0,0-.7.55'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M655.6,422.38v.3h.2V422'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M650.25,419h.85v-.65L651,419'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M658.5,421H659v-.9h-.55'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M633,462.92a.47.47,0,0,1,0,.3c0-.55-.14-1.1-.1-1.65C632.86,462,633,462.48,633,462.92Z'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M638.85,419.92c.13-.43.65-.55.65,0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M645.6,420.67c.1.34.49.49.65.1h.25'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.55,443.42a.63.63,0,0,1,.35.35v.35l-.15.2'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M638.3,420.67H640v-.75H638.3'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.55,441.52a16.63,16.63,0,0,1,2.05.68c.41.15,1.21.32,1.35.78'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M655.8,419v-.65h-.2v.25'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.55,440a16.3,16.3,0,0,1,2,.7c.43.16,1.16.29,1.42.7v1.65c-.72,1.3-2.5-.31-3.4-.25'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M649.15,421.92v19.3a16,16,0,0,1,3.15-1.2'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.8,450.58l0-.05h0l0,0v-.15h0a1.81,1.81,0,0,1,1.75,0h0v.15l0,0a.25.25,0,0,0-.15.05'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M652.35,445.23l.15.4' transform='translate(-621.88 -400.65)' />
      <path
        d='M641.8,451.58a1.11,1.11,0,0,0-.25.25v3.4l.25-.3a.73.73,0,0,0-.25.2.38.38,0,0,0,.25.4v.05'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.45,442.58c-.75,0-1.2.58-1.89.7-.45.08-1.41,0-1.51-.55l0-.05v0a3.61,3.61,0,0,1,1.49-.68,14.82,14.82,0,0,1,1.86-.67'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.65,458.58c-.22.36-.45.63-.64,1a3.23,3.23,0,0,1-.56.89,2.53,2.53,0,0,1-1.86.59l-7.69.51'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.75,401.27A1.67,1.67,0,0,0,641,402a11.53,11.53,0,0,0-.09,3.19v30.11a12.39,12.39,0,0,0,.07,3.31,1.67,1.67,0,0,0,2.74.74c.78-.75.54-2,.54-3V419.21c0-5.51.14-11,0-16.54a1.81,1.81,0,0,0-.5-1.4c2,.58,2.34,2.47,2.8,4.2h.1a1.57,1.57,0,0,1,.25.3h.5v2.8h.2'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M646.25,419.83c-.13-.49-.54-.26-.65.1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.75,451.67v-7.15c0-.27.09-.66-.2-.8'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M652.3,443.73c-.22.19-.15.48-.15.75v7.2'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.5,452.63h0a.71.71,0,0,0,.35-.75c-.16-.29-.42-.36-.7-.5'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.3,456.38v-6l-.1-.1a3,3,0,0,0-1.25,0l-.1.1h0v6'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.2,455.77h0a.33.33,0,0,0,.2-.25l0,0a.25.25,0,0,1,0-.15l-.2-.2h0'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.4,445.63l.15-.15v-5.9'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M657.4,420.88v1h1.1v-2.8h-1.1v1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M650.25,419.77v-.9H650v.9h.1a.85.85,0,0,1,.25.35'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M656.65,419.77v-.9h.15v.9h0a.69.69,0,0,0-.25.4'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M656.5,420.88a.91.91,0,0,0,.25.4h0v.9h-.15v-.9'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M652.5,450.63l0,0v-.05h.1a1.8,1.8,0,0,1,1.6,0h0l.1.1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M638.45,420.67v6h-.15V413.92h.15v6'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M654.2,456.63v-6l-.1-.1a3.14,3.14,0,0,0-1.3,0l-.1.1v6'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M645,421h.9v.9h-.2V421' transform='translate(-621.88 -400.65)' />
      <path
        d='M640.1,421h-.9v.9h.2V421'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M649.75,420.13a.86.86,0,0,1,.25-.35h1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M651,421.27h-1a.93.93,0,0,1-.25-.4'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M646.5,420.67v1h1.15v-.9'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M656,420.88h1.7v-.75H656Z'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M655.15,422.38h.55v-3.75h-.55'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M636.5,420.27l.11-5.87.07-3.59c0-.34-.14-1,.17-1.25a1.43,1.43,0,0,1,.55-.05l0,.05h.1l.1.1c0,3.07.13,6.13.2,9.2'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M647.4,418.88h-.9v1' transform='translate(-621.88 -400.65)' />
      <path
        d='M643.5,445.42l.15-.15a9.62,9.62,0,0,0,0-2.58v-3.32'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M644.25,409.58l.75-.85' transform='translate(-621.88 -400.65)' />
      <path
        d='M641.45,443.48l-.15.15a13.55,13.55,0,0,0,0,3.68v4.12'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.7,443.38a.94.94,0,0,1,.3.25v.1l0,0a.64.64,0,0,0-.35-.6'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.1,443.77v-.25a1.42,1.42,0,0,1,.35-.35'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M663,461.33l-7.17-.45a4.09,4.09,0,0,1-1.83-.33c-.62-.36-.87-1.12-1.2-1.72'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M639,456.63c-2.39,0-4.79-.18-6.4,1.94-.59.78-.74,1.77-1.75,2.14a13.52,13.52,0,0,1-3.64.31l-5.21.32'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M649.85,458.52v.05c1.2.44,1.46,1.38,2.08,2.35a3.81,3.81,0,0,0,2.84,1.55c2.74.26,5.5.37,8.24.55'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M643.7,441.27a15.35,15.35,0,0,1,2,.73c.41.15,1.12.26,1.35.67.11.58-1.05.66-1.42.6-.7-.11-1.17-.69-1.92-.7'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M674,461.58c-2.77-.18-5.6-.2-8.35-.55-1.24-.16-1.39-1-2-1.88a5.17,5.17,0,0,0-2.51-2,11.5,11.5,0,0,0-4.12-.29'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M638.25,441a13.82,13.82,0,0,1,3.2-1.2'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M649.85,456.88l-3.7.15' transform='translate(-621.88 -400.65)' />
      <path
        d='M644.75,422.17v.25h.15v-.65h.85'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M645.75,418.77h-.85v-.65'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M652.55,401.27a4,4,0,0,0-2,1.5,12.17,12.17,0,0,0-.85,2.7h0l0,0h-.05l-.2.2v0H649v2.85h2.4v.1H648.9l-.05-.05h0l0,0v0h.2'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M641.75,401h-.5v-.2h6.1l.05.05h0l.15.15v3.3'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M648.75,401.08h.2V401h3.8l0,.05v.1'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M651.75,438.52a1.74,1.74,0,0,0,2.64,1.22c.95-.64.76-1.88.76-2.87V411.35c0-2.75.11-5.53,0-8.28,0-1.09-.58-2.14-1.85-2.05s-1.55,1.24-1.55,2.28v35.22Z'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M648.75,419.13V401l0-.05v0l0,0h.05l0-.05h6.15v.2H649v4.9h.6l1.8,2.75'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M645,408.63l1.85-2.75h.6V401h-.05v0h-4'
        transform='translate(-621.88 -400.65)'
      />
      <path
        d='M647.4,408.58l-.05,0H645v.1h2.45l0-.05h.1l0,0v-2.75'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M641.65,455.42v1' transform='translate(-621.88 -400.65)' />
      <path d='M656.65,419h-.9' transform='translate(-621.88 -400.65)' />
      <path d='M638.45,420.77h.45' transform='translate(-621.88 -400.65)' />
      <path d='M652.8,401.13V401' transform='translate(-621.88 -400.65)' />
      <path d='M657.1,421h.3' transform='translate(-621.88 -400.65)' />
      <path d='M638.9,419.83h-.45' transform='translate(-621.88 -400.65)' />
      <path d='M643.5,401' transform='translate(-621.88 -400.65)' />
      <path d='M651.35,418.63l0-.25' transform='translate(-621.88 -400.65)' />
      <path d='M657.4,420.08h-.3' transform='translate(-621.88 -400.65)' />
      <path d='M652.3,439.58v5.65' transform='translate(-621.88 -400.65)' />
      <path d='M651.3,422.67l0-.3' transform='translate(-621.88 -400.65)' />
      <path d='M646.25,420.77v-.1' transform='translate(-621.88 -400.65)' />
      <path d='M640.15,440.23V421.77' transform='translate(-621.88 -400.65)' />
      <path d='M640,420.67l.25,1.5' transform='translate(-621.88 -400.65)' />
      <path d='M651,440.48V422' transform='translate(-621.88 -400.65)' />
      <path d='M649.8,420.08h-.5' transform='translate(-621.88 -400.65)' />
      <path d='M650.9,420.88l.3,1.5' transform='translate(-621.88 -400.65)' />
      <path d='M655.9,422v18.45' transform='translate(-621.88 -400.65)' />
      <path d='M656,419l-.15-.65' transform='translate(-621.88 -400.65)' />
      <path d='M649,404.83h-.2' transform='translate(-621.88 -400.65)' />
      <path
        d='M640.4,422.42l0-.25-.2.25'
        transform='translate(-621.88 -400.65)'
      />
      <path d='M643.5,456.38v-1' transform='translate(-621.88 -400.65)' />
      <path d='M640.9,418.42h-.6' transform='translate(-621.88 -400.65)' />
      <path d='M655.8,422.67l.1-.45' transform='translate(-621.88 -400.65)' />
      <path d='M655.6,418.38l0,.25' transform='translate(-621.88 -400.65)' />
      <path d='M652.5,455.67v1' transform='translate(-621.88 -400.65)' />
      <path d='M649.3,421h.5' transform='translate(-621.88 -400.65)' />
      <path d='M656,420.13l-.3-1.5' transform='translate(-621.88 -400.65)' />
      <path d='M655.7,422.38l.3-1.5' transform='translate(-621.88 -400.65)' />
      <path d='M651.2,418.63l-.3,1.5' transform='translate(-621.88 -400.65)' />
      <path d='M654.4,456.63v-1' transform='translate(-621.88 -400.65)' />
      <path d='M657.75,441.23v-19.3' transform='translate(-621.88 -400.65)' />
      <path d='M655.55,422.38l0,.3' transform='translate(-621.88 -400.65)' />
      <path d='M651,422.23l.1.45' transform='translate(-621.88 -400.65)' />
      <path d='M655.75,422h.9' transform='translate(-621.88 -400.65)' />
      <path d='M647.6,404.83h-.2' transform='translate(-621.88 -400.65)' />
      <path d='M649,401' transform='translate(-621.88 -400.65)' />
      <path d='M644.9,422.42l.1-.45' transform='translate(-621.88 -400.65)' />
      <path d='M640.45,418.42l0-.3' transform='translate(-621.88 -400.65)' />
      <path d='M644.7,422.17l0,.25' transform='translate(-621.88 -400.65)' />
      <path d='M644.75,418.13l0,.3' transform='translate(-621.88 -400.65)' />
      <path d='M645,421.77v18.45' transform='translate(-621.88 -400.65)' />
    </g>
  );
};
const DOUBLE = (rotate = 0, m) => {
  return (
    <g
      transform={`rotate(${rotate})`}
      style={{
        strokeWidth: 0.24,
        stroke: 'black',
        fill: 'none',
        fillOpacity: 0
      }}
    >
      <image
        xlinkHref={doubleImage}
        x='0'
        y='0'
        width={m * (rotate % 180 === 0 ? DOUBLE_DEPTH : DOUBLE_WIDTH) + 'px'}
        height={
          2.818181 * m * (rotate % 180 === 0 ? DOUBLE_DEPTH : DOUBLE_WIDTH) +
          'px'
        }
      />
    </g>
  );
};
const DOUBLE_SVG = (rotate = 0) => {
  return (
    <g
      transform={`rotate(${rotate})`}
      style={{
        strokeWidth: 0.24,
        stroke: 'black',
        fill: 'none',
        fillOpacity: 0
      }}
    >
      <path d='M641.75,414.05 L641.75,418.45 L641.75,418.65 L641.75,418.85 L641.75,419.05 L641.75,419.25 L641.75,419.45 L641.75,419.65 L641.75,419.85 L641.75,419.95 L641.75,420.15 L641.75,420.25 L641.75,420.35 L641.75,420.45 L641.75,420.55 L641.75,420.65 L641.75,420.75 L641.85,420.85 L641.95,420.85 L642.05,420.85 L642.15,420.85 L642.15,420.75' />
      <path d='M644.15,420.75 L643.95,420.75 L643.75,420.75 L643.55,420.75 L643.35,420.75 L643.25,420.75 L643.05,420.75 L642.85,420.75 L642.75,420.75 L642.55,420.75 L642.45,420.75 L642.35,420.75 L642.25,420.75 L642.15,420.75 L642.25,420.75 L642.25,420.65 L642.25,420.55 L642.25,420.45 L642.25,420.35 L642.25,420.25 L642.25,420.15 L642.25,419.95 L642.25,419.85 L642.25,419.65 L642.25,419.45 L642.25,419.25 L642.25,419.05 L642.25,418.85 L642.25,418.65 L642.25,418.45 L642.25,414.05' />
      <path d='M650.75,491.25 L650.95,491.25 L650.95,466.15' />
      <path d='M644.65,440.75 L644.65,440.85 L644.65,440.95 L644.65,441.05 L644.65,441.15 L644.65,441.25 L644.65,441.45 L644.65,441.55 L644.65,441.75 L644.65,441.85 L644.65,442.05 L644.65,442.25 L644.65,442.45 L644.65,442.65 L644.65,442.85 L644.65,442.95 L644.65,443.15 L644.65,443.35 L644.65,443.45 L644.65,443.65 L644.65,443.75 L644.65,443.85 L644.65,443.95 L644.65,444.05 L644.75,444.05 L644.75,443.95 L644.75,443.85 L644.75,443.75 L644.75,443.65 L644.75,443.45 L644.75,443.35 L644.75,443.15 L644.75,442.95 L644.75,442.85 L644.75,442.65 L644.75,442.45 L644.75,442.25 L644.75,442.05 L644.75,441.85 L644.75,441.75 L644.75,441.55 L644.75,441.45 L644.75,441.25 L644.75,441.15 L644.75,441.05 L644.75,440.95 L644.75,440.85 L644.75,440.75 z' />
      <path d='M642.25,409.25 L642.35,409.25 L642.45,409.25 L642.55,409.25 L642.75,409.25 L642.85,409.25 L643.05,409.25 L643.25,409.25 L643.35,409.25 L643.55,409.25 L643.65,409.25' />
      <path d='M650.45,464.85 L650.45,459.65 L650.45,459.55 L650.45,459.45 L650.45,459.35 L650.45,459.25 L650.55,459.15 L650.65,459.15' />
      <path d='M644.15,420.25 L643.95,420.25 L643.85,420.25 L643.65,420.25 L643.45,420.25 L643.35,420.25 L643.15,420.25 L642.95,420.25 L642.75,420.35 L642.65,420.35 L642.55,420.35 L642.35,420.35 L642.25,420.35' />
      <path d='M642.75,386.55 L635.65,386.55 L635.65,386.45 L635.65,386.35 L635.65,386.25 L635.65,386.15 L635.65,382.25 L635.65,382.15 L635.65,382.05 L635.65,381.95 L635.65,381.85 L643.45,381.85 L643.45,382.55 L643.55,382.55 L643.55,385.85 L643.45,385.85 L643.45,386.55 L643.35,386.55 L643.15,386.55 L642.85,386.55 L642.65,386.55 L642.65,387.25 L642.65,387.35 L642.65,387.45 L643.45,392.85 L643.45,392.95 L643.55,393.05 L643.75,393.05 L643.85,393.05 L643.95,393.05 L644.05,393.05 L644.15,393.05 L644.05,393.05 L643.85,393.05 L643.55,393.05' />
      <path d='M647.05,443.85 L644.75,443.95' />
      <path d='M646.25,491.25 L646.25,467.65 L645.75,467.65 L645.75,467.55 L645.75,467.45 L645.75,467.35 L645.75,467.25 L645.75,467.05 L645.75,466.95 L645.75,466.75 L645.75,466.55 L645.75,466.45 L645.75,466.25 L645.75,466.05 L645.75,465.85 L645.75,465.65 L645.75,465.45 L645.75,465.25 L645.75,465.05 L645.75,464.85 L645.75,464.65 L645.75,464.55 L645.75,464.35 L645.75,464.25 L645.75,464.15 L645.75,464.05 L645.75,463.95 L645.75,463.85 L646.25,463.85 L646.25,457.25 L646.25,457.55 L646.25,458.15 L646.25,458.65 L646.25,459.25 L646.25,459.85 L646.25,460.35 L646.25,460.95 L646.25,461.55 L646.25,462.15 L646.25,462.75 L646.25,463.35 L646.25,463.95 L646.25,464.55 L646.25,465.15 L646.25,465.75 L646.25,466.35 L646.25,466.95 L646.25,467.55 L646.25,468.15 L646.25,468.75 L646.25,469.35 L646.25,469.95 L646.25,470.55 L646.25,471.15 L646.25,471.75 L646.25,472.35 L646.25,472.85 L646.25,473.45 L646.25,473.95 L646.25,474.45 L646.25,475.05 L646.25,475.55 L646.25,476.05 L646.25,476.55 L646.25,477.05 L646.25,477.45 L646.25,477.95 L646.25,478.35 L646.25,478.75 L646.25,479.15 L646.25,479.55 L646.25,479.95 L646.25,480.35 L646.25,480.65 L646.25,480.95 L646.25,481.25 L646.25,481.55 L646.25,481.85 L646.25,482.15 L646.25,482.35 L646.25,482.55 L646.25,482.75 L646.25,482.95 L646.25,483.05 L646.25,483.25 L646.25,483.35 L646.25,483.45 L646.25,483.55 L646.35,483.75 L646.35,483.95 L646.35,484.15 L646.45,484.35 L646.55,484.45 L646.65,484.65 L646.75,484.75 L646.95,484.95 L647.05,485.05 L647.25,485.15 L647.45,485.15 L647.65,485.25 L647.75,485.25 L647.95,485.25 L648.15,485.25 L648.35,485.25 L648.55,485.15 L648.75,485.15 L648.85,485.05 L649.05,484.95 L649.15,484.75 L649.35,484.65 L649.45,484.45 L649.55,484.35 L649.55,484.15 L649.65,483.95 L649.65,483.75 L649.65,483.55 L649.65,483.45 L649.65,483.35 L649.65,483.25 L649.65,483.05 L649.65,482.95 L649.65,482.75 L649.65,482.55 L649.65,482.35 L649.65,482.15 L649.65,481.85 L649.65,481.55 L649.65,481.25 L649.65,480.95 L649.65,480.65 L649.65,480.35 L649.65,479.95 L649.65,479.55 L649.65,479.15 L649.65,478.75 L649.65,478.35 L649.65,477.95 L649.65,477.45 L649.65,477.05 L649.65,476.55 L649.65,476.05 L649.65,475.55 L649.65,475.05 L649.65,474.45 L649.65,473.95 L649.65,473.45 L649.65,472.85 L649.65,472.35 L649.65,471.75 L649.65,471.15 L649.65,470.55 L649.65,469.95 L649.65,469.35 L649.65,468.75 L649.65,468.15 L649.65,467.55 L649.65,466.95 L649.65,466.35 L649.65,465.75 L649.65,465.15 L649.65,464.55 L649.65,463.95 L649.65,463.35 L649.65,462.75 L649.65,462.15 L649.65,461.55 L649.65,460.95 L649.65,460.35 L649.65,459.85 L649.65,459.25 L649.65,458.65 L649.65,458.15 L649.65,457.55 L649.65,457.25' />
      <path d='M649.65,463.85 L650.25,463.85 L650.25,463.95 L650.25,464.05 L650.25,464.15 L650.25,464.25 L650.25,464.35 L650.25,464.55 L650.25,464.65 L650.25,464.85 L650.25,465.05 L650.25,465.25 L650.25,465.45 L650.25,465.65 L650.25,465.85 L650.25,466.05 L650.25,466.25 L650.25,466.45 L650.25,466.55 L650.25,466.75 L650.25,466.95 L650.25,467.05 L650.25,467.25 L650.25,467.35 L650.25,467.45 L650.25,467.55 L650.25,467.65 L649.65,467.65' />
      <path d='M646.95,377.45 L647.05,377.45 L647.05,377.55 L647.05,377.45 L646.95,377.45 L646.85,377.35 L646.75,377.35 L646.65,377.45 L646.55,377.45 L646.55,377.55 L646.45,377.55 L646.55,377.55 L646.55,377.45 L646.65,377.45 L646.75,377.35 L646.85,377.35 z' />
      <path d='M646.25,392.85 L645.85,392.85 L645.85,394.65 L645.85,394.75 L645.85,394.85 L645.85,394.95 L645.85,395.05 L645.85,395.25 L645.85,395.35 L645.85,395.55 L645.85,395.75 L645.85,395.95 L645.85,396.15 L645.85,396.35 L645.85,396.55 L645.85,396.75 L645.85,396.95 L645.85,397.15 L645.85,397.35 L645.85,397.55 L645.85,397.75 L645.85,397.95 L645.85,398.15 L645.85,398.25 L645.85,398.45 L645.85,398.55 L645.85,398.65 L645.85,398.75 L645.85,398.85 L645.85,398.95 L645.65,398.95 L645.65,398.85 L645.65,398.75 L645.65,398.65 L645.65,398.55 L645.65,398.45 L645.65,398.25 L645.65,398.15 L645.65,397.95 L645.65,397.75 L645.65,397.55 L645.65,397.35 L645.65,397.15 L645.65,396.95 L645.65,396.75 L645.65,396.55 L645.65,396.35 L645.65,396.15 L645.65,395.95 L645.65,395.75 L645.65,395.55 L645.65,395.35 L645.65,395.25 L645.65,395.05 L645.65,394.95 L645.65,394.85 L645.65,394.75 L645.65,394.65 L645.35,396.25' />
      <path d='M645.35,459.15 L645.45,459.15 L645.45,459.25 L645.55,459.25 L645.55,459.35 L645.55,459.45 L645.55,459.55 L645.55,459.65 L645.55,464.85' />
      <path d='M649.65,396.15 L649.95,396.15 L649.95,396.25 L649.95,396.35 L649.95,396.45 L649.95,396.55 L649.95,396.75 L649.95,396.85 L649.95,396.95 L649.95,397.05 L649.95,397.15 L649.95,397.25 L649.95,397.35 L649.95,397.45 L649.65,397.45' />
      <path d='M650.45,491.25 L645.55,491.25' />
      <path d='M649.65,392.85 L650.15,392.85 L650.15,394.65 L650.15,394.75 L650.15,394.85 L650.15,394.95 L650.15,395.05 L650.15,395.25 L650.15,395.35 L650.15,395.55 L650.15,395.75 L650.15,395.95 L650.15,396.15 L650.15,396.35 L650.15,396.55 L650.15,396.75 L650.15,396.95 L650.15,397.15 L650.15,397.35 L650.15,397.55 L650.15,397.75 L650.15,397.95 L650.15,398.15 L650.15,398.25 L650.15,398.45 L650.15,398.55 L650.15,398.65 L650.15,398.75 L650.15,398.85 L650.15,398.95 L650.35,398.95 L650.35,398.85 L650.35,398.75 L650.35,398.65 L650.35,398.55 L650.35,398.45 L650.35,398.25 L650.35,398.15 L650.35,397.95 L650.35,397.75 L650.35,397.55 L650.35,397.35 L650.35,397.15 L650.35,396.95 L650.35,396.75 L650.35,396.55 L650.35,396.35 L650.35,396.15 L650.35,395.95 L650.35,395.75 L650.35,395.55 L650.35,395.35 L650.35,395.25 L650.35,395.05 L650.35,394.95 L650.35,394.85 L650.35,394.75 L650.35,394.65 L650.25,394.65 L650.15,394.65 L650.15,394.75' />
      <path d='M648.25,373.05 L648.15,373.05 L648.05,373.05 L647.95,373.05 L647.85,373.05 L647.75,373.05 L647.85,373.05 L647.95,373.05 L648.05,373.05 L648.15,373.05 L648.25,373.05 L648.15,373.05 L648.05,373.05 L647.95,373.05 L647.85,373.05 L647.75,373.05 L647.85,373.05 L647.95,373.05 L648.05,373.05 L648.15,373.05 z' />
      <path d='M646.25,396.15 L646.05,396.15 L646.05,396.25 L646.05,396.35 L646.05,396.45 L646.05,396.55 L646.05,396.75 L646.05,396.85 L646.05,396.95 L646.05,397.05 L646.05,397.15 L646.05,397.25 L646.05,397.35 L646.05,397.45 L646.25,397.45' />
      <path d='M652.25,448.85 L652.25,448.75 L652.25,448.65 L652.25,448.55 L652.25,448.45 L652.25,448.35 L652.25,448.15 L652.25,447.95 L652.25,447.75 L652.25,447.55 L652.25,447.35 L652.25,447.15 L652.25,446.85 L652.25,446.65 L652.25,446.35 L652.25,446.05 L652.25,445.75 L652.25,445.45 L652.25,445.05 L652.25,444.75 L652.25,444.45 L652.25,444.05 L652.25,443.75 L652.25,443.35 L652.25,442.95 L652.25,442.65 L652.25,442.25 L652.25,441.85 L652.25,441.55 L652.25,441.15 L652.25,440.85 L652.25,440.45 L652.25,440.15 L652.25,439.75 L652.25,439.45 L652.25,439.15 L652.25,438.85 L652.25,438.55 L652.25,438.25 L652.25,437.95 L652.25,437.75 L652.25,437.45 L652.25,437.25 L652.25,437.05 L652.25,436.85 L652.25,436.75 L652.25,436.55 L652.25,436.45 L652.25,436.35 L652.25,436.25 L652.25,436.15 L652.25,436.05 L652.15,436.05 L652.15,436.15 L652.15,436.25 L652.15,436.35 L652.15,436.45 L652.15,436.55 L652.15,436.75 L652.15,436.85 L652.15,437.05 L652.15,437.25 L652.15,437.45 L652.15,437.75 L652.15,437.95 L652.15,438.25 L652.15,438.55 L652.15,438.85 L652.15,439.15 L652.15,439.45 L652.15,439.75 L652.15,440.15 L652.15,440.45 L652.15,440.85 L652.15,441.15 L652.15,441.55 L652.15,441.85 L652.15,442.25 L652.15,442.65 L652.15,442.95 L652.15,443.35 L652.15,443.75 L652.15,444.05 L652.15,444.45 L652.15,444.75 L652.15,445.05 L652.15,445.45 L652.15,445.75 L652.15,446.05 L652.15,446.35 L652.15,446.65 L652.15,446.85 L652.15,447.15 L652.15,447.35 L652.15,447.55 L652.15,447.75 L652.15,447.95 L652.15,448.15 L652.15,448.35 L652.15,448.45 L652.15,448.55 L652.15,448.65 L652.15,448.75 L652.15,448.85 z' />
      <path d='M646.15,377.35 L646.15,377.25 L646.05,377.25 L645.85,377.25 L646.05,377.25 L646.15,377.25 L646.15,377.35 L646.15,391.05 L646.15,391.15 L646.15,391.05' />
      <path d='M649.85,377.35 L649.85,377.25 L649.95,377.25 L650.15,377.25 L649.95,377.25 L649.85,377.25 L649.85,377.35 L649.85,391.05 L649.85,391.15 L649.85,391.05' />
      <path d='M645.85,394.75 L645.65,394.65' />
      <path d='M650.25,398.95 L650.25,407.65' />
      <path d='M650.15,398.75 L650.15,400.65 L650.15,407.75 L649.95,407.85 L649.85,407.95' />
      <path d='M645.85,398.75 L645.85,407.75' />
      <path d='M645.75,398.95 L645.75,407.65' />
      <path d='M644.15,396.05 L644.35,395.95 L644.45,395.95 L644.55,395.95 L644.75,395.95 L644.85,395.95 L644.95,396.05 L645.15,396.05 L645.25,396.15 L645.35,396.25 L645.35,396.35 L645.35,396.55 L645.45,396.85 L645.45,396.95 L645.45,397.15 L645.55,397.25 L645.55,397.35 L645.55,397.45 L645.55,397.55 L645.55,407.35 L645.55,407.45 L645.65,407.55 L645.85,407.75 L645.95,407.85 L646.15,407.95 L646.35,408.05 L646.45,408.15 L646.65,408.25 L646.85,408.25 L647.05,408.35 L647.35,408.35 L647.55,408.35 L647.75,408.35 L647.85,408.35 L647.95,408.35 L648.05,408.35 L648.15,408.35 L648.25,408.35 L648.45,408.35 L648.65,408.35 L648.85,408.35 L649.05,408.25 L649.25,408.25 L649.45,408.15 L649.65,408.05 L649.85,407.95 L649.85,397.45' />
      <path d='M643.65,407.35 L643.65,396.95 L643.65,396.85 L643.75,396.75 L643.75,396.55 L643.75,396.45 L643.75,396.35 L643.85,396.25 L643.95,396.15 L644.05,396.15 L644.15,396.05 L644.15,372.75 L644.25,372.75 L645.85,372.75 L650.15,372.75 L651.75,372.75 L651.85,372.75 L651.85,396.05' />
      <path d='M652.25,407.35 L652.25,396.95 L652.25,396.85 L652.25,396.65 L652.25,396.55 L652.15,396.45 L652.15,396.35 L652.15,396.25 L652.05,396.15 L651.95,396.15 L651.75,396.05 L651.65,395.95 L651.55,395.95 L651.35,395.95 L651.25,395.95 L651.15,395.95 L650.95,396.05 L650.85,396.05 L650.75,396.15 L650.65,396.25 L650.65,396.45 L650.55,396.65 L650.55,396.85 L650.55,397.05 L650.45,397.15 L650.45,397.35 L650.45,397.45 L650.45,397.55 L650.45,407.35' />
      <path d='M627.55,410.95 L627.45,410.95 L627.45,410.85 L627.45,410.95 L627.45,411.05 L627.45,411.15 L627.45,411.25 L627.45,411.35 L627.45,411.45 L627.45,411.55 L627.45,411.75 L627.45,411.85 L627.45,411.95 L627.45,412.15 L627.45,412.25 L627.45,412.35 L627.45,412.45 L627.45,412.55 L627.55,412.55 L627.55,412.45 L627.55,412.35 L627.55,412.25 L627.55,412.15 L627.55,411.95 L627.55,411.85 L627.55,411.75 L627.55,411.55 L627.55,411.45 L627.55,411.35 L627.55,411.25 L627.55,411.15 L627.55,411.05 z' />
      <path d='M650.15,407.75 L650.25,407.55 L650.35,407.45 L650.45,407.35 L650.55,407.25 L650.65,407.15 L650.85,407.05 L650.95,406.95 L651.15,406.95 L651.25,406.95 L651.45,406.95 L651.55,406.95 L651.75,406.95 L651.85,407.05 L652.05,407.15 L652.15,407.25 L652.25,407.35 L652.35,407.45 L652.35,407.55 L652.45,407.65 L652.45,407.85 L652.45,407.95 L652.45,408.75' />
      <path d='M668.45,410.85 L668.55,410.95 L668.55,411.05 L668.55,411.15 L668.55,411.25 L668.55,411.35 L668.55,411.45 L668.55,411.55 L668.55,411.75 L668.55,411.85 L668.55,411.95 L668.55,412.15 L668.55,412.25 L668.55,412.35 L668.55,412.45 L668.45,412.55 L668.45,412.45 L668.45,412.35 L668.45,412.25 L668.45,412.15 L668.45,411.95 L668.45,411.85 L668.45,411.75 L668.45,411.55 L668.45,411.45 L668.45,411.35 L668.45,411.25 L668.45,411.15 L668.45,411.05 L668.45,410.95 z' />
      <path d='M646.95,410.55 L646.95,410.35 L646.95,410.25 L647.05,410.15 L647.15,410.05 L647.25,409.95 L647.35,409.85 L647.45,409.75 L647.55,409.65 L647.65,409.65 L647.85,409.65 L647.95,409.55 L648.15,409.65 L648.25,409.65 L648.45,409.65 L648.55,409.75 L648.65,409.85 L648.75,409.95 L648.85,410.05 L648.95,410.15 L648.95,410.25 L649.05,410.35 L649.05,410.55' />
      <path d='M646.05,452.65 L645.85,452.85 L645.65,453.05 L645.45,453.25 L645.25,453.45 L645.05,453.65 L644.85,453.85 L644.75,454.15 L644.65,454.35 L644.55,454.55 L644.45,454.75 L644.45,454.95 L644.35,455.15 L644.35,455.35 L644.45,455.55 L644.45,455.75 L644.55,455.95 L644.55,456.15 L644.65,456.35 L644.85,456.45 L644.95,456.65 L645.05,456.75 L645.25,456.95 L645.45,457.05 L645.65,457.05 L645.85,457.15 L646.05,457.25 L646.25,457.25 L646.45,457.25 L646.65,457.25 L646.85,457.15 L647.05,457.15 L647.25,457.05 L647.35,456.95 L647.55,456.85 L647.75,456.75 L647.85,456.55 L647.95,456.45 L648.15,456.55 L648.25,456.75 L648.45,456.85 L648.55,456.95 L648.75,457.05 L648.95,457.15 L649.15,457.15 L649.35,457.25 L649.55,457.25 L649.75,457.25 L649.95,457.25 L650.15,457.15 L650.35,457.05 L650.55,457.05 L650.75,456.95 L650.85,456.75 L651.05,456.65 L651.15,456.45 L651.25,456.35 L651.35,456.15 L651.45,455.95 L651.55,455.75 L651.55,455.55 L651.55,455.35 L651.55,455.15 L651.55,454.95 L651.55,454.75 L651.45,454.55 L651.35,454.35 L651.25,454.15 L651.05,453.85 L650.95,453.65 L650.75,453.45 L650.55,453.25 L650.35,453.05 L650.15,452.85 L649.95,452.65 L649.85,452.75 L649.65,452.75 L649.45,452.85 L649.15,452.95 L648.85,453.05 L648.45,453.15 L647.95,453.25 L647.95,453.85 L647.95,454.45 L647.95,454.85 L647.95,455.25 L647.95,455.65 L647.95,455.85 L647.95,456.05 L647.95,456.25 L647.95,456.35 L647.95,456.45' />
      <path d='M646.55,411.55 L646.55,411.45 L646.55,411.25 L646.65,411.15 L646.65,410.95 L646.75,410.85 L646.85,410.75 L647.05,410.55 L647.15,410.45 L647.35,410.35 L647.45,410.25 L647.65,410.25 L647.85,410.15 L647.95,410.15 L648.15,410.15 L648.35,410.25 L648.55,410.25 L648.65,410.35 L648.85,410.45 L648.95,410.55 L649.05,410.65 L649.15,410.75 L649.25,410.85 L649.35,411.05 L649.45,411.15 L649.45,411.35 L649.45,411.45 L649.45,411.55 L649.45,411.75 L649.45,411.85 L649.35,412.05 L649.25,412.15' />
      <path d='M649.05,416.75 L649.15,416.65 L649.15,441.25 L649.15,441.35 L649.05,441.45 L649.05,441.55 L648.95,441.65 L648.95,441.75' />
      <path d='M649.25,412.35 L649.25,411.55 L649.25,411.45 L649.25,411.35 L649.25,411.25 L649.15,411.05 L649.05,410.95 L648.95,410.85 L648.85,410.75 L648.75,410.65 L648.65,410.55 L648.45,410.45 L648.35,410.45 L648.15,410.45 L647.95,410.45 L647.85,410.45 L647.65,410.45 L647.55,410.45 L647.35,410.55 L647.25,410.65 L647.05,410.75 L646.95,410.85 L646.85,410.95 L646.75,411.05 L646.75,411.25 L646.65,411.35 L646.65,411.45 L646.65,411.55 L646.65,412.35' />
      <path d='M649.25,415.25 L648.95,414.75' />
      <path d='M649.95,452.65 L648.75,447.25 L648.65,447.15 L648.65,447.05 L648.55,446.95 L648.45,446.85 L648.35,446.75 L648.25,446.75 L648.15,446.65 L647.95,446.65 L647.85,446.65 L647.75,446.75 L647.65,446.75 L647.55,446.85 L647.45,446.95 L647.35,447.05 L647.25,447.15 L647.25,447.25 L646.05,452.65 L646.15,452.75 L646.35,452.75 L646.55,452.85 L646.75,452.95 L647.15,453.05 L647.55,453.15 L647.95,453.25' />
      <path d='M646.65,414.05 L646.65,415.25 L646.65,415.45 L646.55,415.55 L646.55,415.75 L646.55,415.85 L646.55,416.05 L646.55,416.15 L646.65,416.35 L646.65,416.45 L646.75,416.65 L646.85,416.75 L646.95,416.75' />
      <path d='M647.05,414.75 L647.05,414.85 L647.05,414.95 L646.85,415.05 L646.75,415.15 L646.65,415.25' />
      <path d='M649.45,415.85 L649.45,415.75 L649.45,415.65 L649.45,415.45 L649.55,415.35 L649.55,415.15 L649.65,414.95 L649.65,414.75 L649.65,414.55 L649.65,414.45 L649.65,414.35 L649.65,414.25 L649.65,414.05' />
      <path d='M646.55,415.45 L646.55,415.85' />
      <path d='M649.05,417.65 L648.95,415.45' />
      <path d='M647.05,415.45 L646.95,417.65' />
      <path d='M648.95,414.05 L648.95,416.45 L648.95,416.55 L648.85,416.55 L648.75,416.55 L648.55,416.55 L648.45,416.55 L648.35,416.55 L648.25,416.45 L648.15,416.45 L647.95,416.45 L647.75,416.45 L647.65,416.45 L647.55,416.55 L647.45,416.55 L647.35,416.55 L647.25,416.55 L647.15,416.55 L647.05,416.55 L647.05,416.45 L647.05,414.05' />
      <path d='M648.95,448.15 L648.95,418.05 L648.95,417.85 L649.05,417.75 L649.05,417.65 L649.05,417.55 L648.95,417.35 L648.95,417.25 L648.85,417.15 L648.75,417.05 L648.65,416.95 L648.55,416.85 L648.45,416.85 L648.25,416.75 L648.15,416.75 L647.95,416.75 L647.85,416.75 L647.65,416.75 L647.55,416.85 L647.45,416.85 L647.35,416.95 L647.25,417.05 L647.15,417.15 L647.05,417.25 L646.95,417.35 L646.95,417.55 L646.95,417.65 L646.95,417.75 L646.95,417.85 L647.05,418.05 L647.05,448.15' />
      <path d='M650.95,449.65 L651.75,449.65 L651.75,449.55 L651.85,449.55 L651.85,442.95' />
      <path d='M642.85,381.85 L642.85,381.65 L643.35,381.65 L643.35,381.85' />
      <path d='M649.45,415.45 L648.95,414.85' />
      <path d='M647.05,418.05 L647.15,418.15 L647.25,418.25 L647.35,418.35 L647.45,418.45 L647.55,418.45 L647.65,418.55 L647.85,418.55 L647.95,418.55 L648.15,418.55 L648.25,418.55 L648.45,418.45 L648.55,418.45 L648.65,418.35 L648.75,418.25 L648.85,418.15 L648.95,418.05' />
      <path d='M648.95,377.45 L648.85,377.55 L648.95,377.45 L649.05,377.45 L649.05,377.35 L649.15,377.35 L649.25,377.35 L649.35,377.45 L649.45,377.55 L649.35,377.45 L649.25,377.35 L649.15,377.35 L649.05,377.35 L649.05,377.45 z' />
      <path d='M649.15,416.65 L649.25,416.45 L649.35,416.35 L649.45,416.15 L649.45,416.05 L649.45,415.85 L649.45,415.75 L649.45,415.55 L649.35,415.45 L649.25,415.25 L649.25,414.05' />
      <path d='M647.05,446.55 L646.95,446.65 L646.75,446.75 L646.65,446.95 L646.55,447.05 L646.45,447.25 L646.35,447.35 L646.35,447.55 L646.35,447.75 L646.25,447.95 L646.25,448.05 L646.25,448.15 L646.25,448.25 L646.25,448.35 L646.25,448.45 L646.25,448.65 L646.25,448.75 L646.25,448.95 L646.25,449.15 L646.25,449.45 L646.25,449.65 L646.25,449.95 L646.25,450.25 L646.25,450.55 L646.25,450.85 L646.25,451.25 L646.25,451.45' />
      <path d='M651.85,375.35 L651.95,375.35 L652.05,375.35 L652.15,375.35 L652.25,375.35 L652.45,375.35 L652.45,375.45 L652.55,375.55 L653.25,381.05 L653.25,381.15 L653.25,381.25 L653.25,381.85' />
      <path d='M647.05,441.75 L646.95,441.55 L646.85,441.45 L646.85,441.35 L646.85,441.25 L646.85,416.65' />
      <path d='M644.15,375.35 L644.05,375.35 L643.95,375.35 L643.85,375.35 L643.75,375.35 L643.55,375.35 L643.45,375.45 L643.45,375.55 L642.65,381.05 L642.65,381.15 L642.65,381.25 L642.65,381.85' />
      <path d='M649.65,451.45 L649.65,451.25 L649.65,450.85 L649.65,450.55 L649.65,450.25 L649.65,449.95 L649.65,449.65 L649.65,449.45 L649.65,449.15 L649.65,448.95 L649.65,448.75 L649.65,448.65 L649.65,448.45 L649.65,448.35 L649.65,448.25 L649.65,448.15 L649.65,448.05 L649.65,447.95 L649.65,447.75 L649.65,447.55 L649.55,447.35 L649.55,447.25 L649.45,447.05 L649.35,446.95 L649.15,446.75 L649.05,446.65 L648.95,446.55' />
      <path d='M646.65,412.15 L646.65,412.05 L646.55,411.85 L646.55,411.75 L646.55,411.55 L646.55,411.45 L646.55,411.35 L646.55,411.15 L646.65,411.05 L646.65,410.85 L646.75,410.75 L646.85,410.65 L647.05,410.55 L647.15,410.45 L647.35,410.45 L647.45,410.35 L647.65,410.35 L647.85,410.25 L647.95,410.25 L648.15,410.25 L648.35,410.35 L648.55,410.35 L648.65,410.45 L648.85,410.45 L648.95,410.55 L649.05,410.75 L649.15,410.85 L649.25,410.95 L649.35,411.15 L649.45,411.25 L649.45,411.45 L649.45,411.55' />
      <path d='M653.25,386.55 L653.25,387.25 L653.25,387.35 L653.25,387.45 L652.55,392.85 L652.45,392.95 L652.45,393.05 L652.25,393.05 L652.15,393.05 L652.05,393.05 L651.95,393.05 L651.85,393.05 L651.95,393.05 L652.15,393.05 L652.45,393.05' />
      <path d='M645.55,407.35 L645.35,407.25 L645.25,407.15 L645.15,407.05 L645.05,406.95 L644.85,406.95 L644.65,406.95 L644.55,406.95 L644.35,406.95 L644.25,406.95 L644.05,407.05 L643.95,407.15 L643.85,407.25 L643.75,407.35 L643.65,407.45 L643.55,407.55 L643.55,407.65 L643.45,407.85 L643.45,407.95 L643.45,408.75 L643.35,408.75 L643.15,408.75 L642.95,408.75 L642.75,408.75 L642.65,408.75 L642.55,408.75 L642.35,408.75 L642.25,408.75 L642.15,408.75 L642.05,408.75 L641.95,408.75 L641.85,408.75 L641.85,408.85 L641.75,408.85 L641.75,408.95 L641.75,409.05 L641.75,409.15 L641.75,409.25 L641.75,409.35 L641.75,409.45 L641.75,409.65 L641.75,409.75 L641.75,409.95 L641.75,410.15 L641.75,410.25 L641.75,410.45 L641.75,410.75 L641.75,410.95 L641.75,411.15 L641.75,411.35 L641.75,412.35' />
      <path d='M653.15,381.85 L653.15,381.65 L652.65,381.65 L652.65,381.85' />
      <path d='M652.25,441.35 L653.35,441.35 L653.35,441.45 L653.35,442.15 L653.35,442.25 L653.35,442.35 L653.35,442.55 L653.35,442.65 L653.35,442.75 L653.35,442.95 L653.35,443.05 L653.35,443.15 L653.35,443.25 L653.35,443.35 L653.35,443.45 L653.35,443.55 L652.25,443.55' />
      <path d='M644.05,441.35 L642.95,441.35 L642.95,441.45 L642.95,442.15 L642.95,442.25 L642.95,442.35 L642.95,442.55 L642.95,442.65 L642.95,442.75 L642.95,442.95 L642.95,443.05 L642.95,443.15 L642.95,443.25 L642.95,443.35 L642.95,443.45 L642.95,443.55 L644.05,443.55 L644.05,443.45 L644.05,443.35 L644.05,443.25 L644.05,443.15 L644.05,443.05 L644.05,442.95 L644.05,442.75 L644.05,442.65 L644.05,442.55 L644.05,442.35 L644.05,442.25 L644.05,442.15 L644.05,441.45 z' />
      <path d='M652.55,381.85 L652.45,381.85 L660.35,381.85 L660.35,381.95 L660.35,382.05 L660.35,382.15 L660.35,382.25 L660.35,386.15 L660.35,386.25 L660.35,386.35 L660.35,386.45 L660.35,386.55 L653.25,386.55 L653.15,386.55 L652.85,386.55 L652.65,386.55 L652.45,386.55 L652.45,385.85 L652.35,385.85 L652.35,382.55 L652.45,382.55 L652.45,381.85' />
      <path d='M653.35,441.85 L653.45,441.85 L653.65,441.85 L653.75,441.95 L653.85,441.95 L653.95,442.05 L653.95,442.15 L654.05,442.25 L654.05,442.35 L654.05,442.45 L654.05,442.55 L653.95,442.65 L653.95,442.75 L653.85,442.85 L653.75,442.95 L653.65,442.95 L653.45,443.05 L653.35,443.05' />
      <path d='M652.75,441.35 L652.85,436.75 L652.95,436.65 L652.95,436.55 L652.95,436.45 L653.05,436.45 L653.15,436.35 L653.25,436.35 L653.35,436.35 L653.45,436.35 L653.55,436.35 L653.65,436.35 L653.65,436.45 L653.75,436.45 L653.85,436.55 L653.85,436.65 L653.85,436.75 L654.05,442.45' />
      <path d='M646.55,377.55 L646.55,377.45 L646.65,377.45 L646.75,377.35 L646.85,377.35 L646.95,377.45 L647.05,377.45 L647.05,377.55 L647.05,377.45 L646.95,377.45 L646.85,377.35 L646.75,377.35 L646.65,377.45 L646.55,377.45 L646.55,377.55 L646.45,377.55 z' />
      <path d='M652.25,466.15 L652.25,466.05 L652.25,465.95 L652.25,465.85 L652.25,465.75 L652.25,465.65 L652.25,465.55 L652.25,465.45 L652.25,465.35 L651.75,465.35 L651.75,465.45 L651.65,465.55 L651.65,465.65 L651.65,465.75 L651.55,465.75 L651.45,465.75 L651.35,465.75 L651.25,465.75 L651.15,465.75 L651.05,465.75 L651.05,465.65 L651.05,465.55 L650.95,465.45 L650.95,465.35 L650.55,465.35 L650.55,465.45 L650.55,465.55 L650.55,465.65 L650.55,465.75 L650.55,465.85 L650.55,465.95 L650.55,466.05 L650.55,466.15 z' />
      <path d='M646.55,411.35 L646.25,411.15 L646.25,411.35 L646.25,411.65 L646.25,411.95 L646.25,412.25 L646.25,412.35 L646.25,411.15 L645.85,410.85 L645.45,410.65 L645.05,410.35 L644.65,410.05 L644.25,409.75 L643.85,409.45 L643.75,409.35 L643.65,409.25 L643.55,409.15 L643.55,409.05 L643.45,408.85 L643.45,408.75 L643.45,408.65 L643.55,408.45 L643.55,408.35 L643.65,408.25 L643.75,408.05 L643.85,407.95 L643.95,407.95 L644.05,407.85 L644.25,407.75 L644.35,407.75 L644.55,407.75 L644.65,407.75 L644.85,407.75 L645.05,407.75 L645.15,407.85 L645.25,407.95 L645.35,408.05 L645.55,408.15 L645.55,408.25 L645.65,408.35 L645.85,408.55 L645.95,408.65 L646.15,408.75 L646.35,408.85 L646.45,408.95 L646.65,409.05 L646.85,409.05 L647.05,409.15 L647.35,409.15 L647.55,409.15 L647.75,409.15 L647.85,409.15 L647.95,409.05 L648.05,409.05 L648.15,409.15 L648.25,409.15 L648.45,409.15 L648.65,409.15 L648.85,409.15 L649.05,409.05 L649.25,409.05 L649.45,408.95 L649.65,408.85 L649.85,408.75 L649.95,408.65 L650.15,408.55 L650.25,408.35 L650.35,408.25 L650.45,408.15 L650.55,408.05 L650.65,407.95 L650.85,407.85 L650.95,407.75 L651.15,407.75 L651.25,407.75 L651.45,407.75 L651.55,407.75 L651.75,407.75 L651.85,407.85 L652.05,407.95 L652.15,407.95 L652.25,408.05 L652.35,408.25 L652.35,408.35 L652.45,408.45 L652.45,408.65 L652.45,408.75 L652.45,408.85 L652.45,409.05 L652.35,409.15 L652.35,409.25 L652.25,409.35 L652.05,409.45 L651.75,409.75 L651.35,410.05 L650.95,410.35 L650.55,410.65 L650.15,410.85 L649.75,411.15 L649.75,412.35' />
      <path d='M643.35,386.55 L643.35,386.75 L642.85,386.75 L642.85,386.55' />
      <path d='M646.25,440.95 L646.25,414.05 L646.25,414.25 L646.25,414.35 L646.25,414.45 L646.25,414.55 L646.35,414.75 L646.35,414.95 L646.35,415.15 L646.45,415.35 L646.55,415.45 L646.65,415.35 L646.65,415.15 L646.75,415.05 L646.85,414.95 L647.05,414.85' />
      <path d='M649.65,412.35 L649.65,411.15' />
      <path d='M646.55,377.95 L646.45,377.85' />
      <path d='M649.65,408.05 L649.65,407.55 L649.65,407.05 L649.65,406.55 L649.65,406.05 L649.65,405.45 L649.65,404.95 L649.65,404.45 L649.65,403.85 L649.65,403.35 L649.65,402.75 L649.65,402.15 L649.65,401.55 L649.65,400.95 L649.65,400.35 L649.65,399.75 L649.65,399.15 L649.65,398.55 L649.65,397.95 L649.65,397.35 L649.65,396.75 L649.65,396.15 L649.65,395.55 L649.65,394.95 L649.65,394.35 L649.65,393.75 L649.65,393.15 L649.65,392.55 L649.65,391.95 L649.65,391.35 L649.65,390.85 L649.65,390.25 L649.65,389.65 L649.65,389.15 L649.65,388.55 L649.65,388.05 L649.65,387.55 L649.65,386.95 L649.65,386.45 L649.65,386.05 L649.65,385.55 L649.65,385.05 L649.65,384.65 L649.65,384.15 L649.65,383.75 L649.65,383.35 L649.65,382.95 L649.65,382.55 L649.65,382.25 L649.65,381.85 L649.65,381.55 L649.65,381.25 L649.65,380.95 L649.65,380.65 L649.65,380.45 L649.65,380.15 L649.65,379.95 L649.65,379.75 L649.65,379.65 L649.65,379.45 L649.65,379.35 L649.65,379.25 L649.65,379.15 L649.65,379.05 L649.65,378.95 L649.65,378.75 L649.65,378.55 L649.55,378.35 L649.55,378.25 L649.45,378.05 L649.35,377.95 L649.15,377.75 L649.05,377.65 L648.85,377.55 L648.75,377.45 L648.55,377.35 L648.35,377.35 L648.15,377.25 L647.95,377.25 L647.75,377.25 L647.65,377.35 L647.45,377.35 L647.25,377.45 L647.05,377.55 L646.95,377.65 L646.75,377.75 L646.65,377.95' />
      <path d='M627.45,412.55 L635.75,412.55 L635.85,412.55 L636.05,412.55 L636.25,412.55 L636.45,412.55 L636.65,412.55 L636.75,412.65 L636.95,412.65 L637.05,412.65 L637.25,412.75 L637.35,412.75 L637.45,412.75 L637.45,412.85 L637.55,412.85 L637.65,412.95 L637.85,413.15 L638.05,413.25 L638.25,413.35 L638.45,413.45 L638.65,413.55 L638.85,413.65 L639.15,413.75 L639.35,413.75 L639.65,413.85 L639.95,413.85 L640.15,413.95 L640.45,413.95 L640.75,414.05 L641.05,414.05 L641.35,414.05 L641.65,414.05 L641.95,414.05 L647.25,414.05 L647.35,414.05 L647.45,414.05 L647.55,413.95 L647.55,413.85 L647.65,413.85 L647.75,413.95 L647.85,413.95 L647.95,413.95 L648.05,413.95 L648.15,413.95 L648.25,413.85 L648.35,413.85 L648.35,413.95 L648.45,413.95 L648.55,414.05 L648.65,414.05 L653.95,414.05 L654.15,414.05 L654.45,414.05 L654.75,414.05 L655.05,414.05 L655.25,414.05 L655.55,413.95 L655.85,413.95 L656.15,413.85 L656.35,413.85 L656.65,413.75 L656.85,413.65 L657.15,413.65 L657.35,413.55 L657.55,413.45 L657.75,413.35 L657.95,413.25 L658.15,413.05 L658.35,412.95 L658.35,412.85 L658.45,412.85 L658.55,412.85 L658.65,412.75 L658.75,412.75 L658.85,412.65 L658.95,412.65 L659.15,412.65 L659.25,412.55 L659.45,412.55 L659.65,412.55 L659.85,412.55 L660.05,412.55 L660.25,412.55 L668.45,412.55' />
      <path d='M644.15,442.95 L644.15,449.55 L644.25,449.65 L644.95,449.65' />
      <path d='M643.85,396.35 L642.35,396.35 L642.35,396.45 L642.35,396.55 L642.35,396.65 L642.35,396.75 L642.35,396.85 L642.35,396.95 L642.35,397.05 L642.35,397.15 L642.35,397.25 L643.65,397.25' />
      <path d='M652.15,396.35 L653.55,396.35 L653.55,396.45 L653.55,396.55 L653.55,396.65 L653.55,396.75 L653.55,396.85 L653.55,396.95 L653.55,397.05 L653.55,397.15 L653.55,397.25 L652.25,397.25' />
      <path d='M652.65,386.55 L652.65,386.75 L653.15,386.75 L653.15,386.55' />
      <path d='M668.45,410.85 L660.25,410.85 L660.15,410.85 L659.85,410.85 L659.65,410.85 L659.35,410.85 L659.15,410.95 L658.95,410.95 L658.65,411.05 L658.45,411.05 L658.25,411.15 L658.05,411.15 L657.85,411.25 L657.65,411.35 L657.45,411.45 L657.25,411.55 L657.15,411.65 L657.15,411.75 L657.05,411.75 L656.95,411.85 L656.85,411.85 L656.75,411.95 L656.65,411.95 L656.45,412.05 L656.35,412.15 L656.15,412.15 L655.95,412.15 L655.75,412.25 L655.55,412.25 L655.25,412.35 L655.05,412.35 L654.85,412.35 L654.55,412.35 L654.35,412.35 L654.05,412.35 L653.95,412.35 L641.95,412.35 L641.85,412.35 L641.55,412.35 L641.35,412.35 L641.05,412.35 L640.85,412.35 L640.65,412.35 L640.35,412.25 L640.15,412.25 L639.95,412.15 L639.75,412.15 L639.55,412.05 L639.45,412.05 L639.25,411.95 L639.15,411.95 L639.05,411.85 L638.95,411.85 L638.85,411.75 L638.75,411.65 L638.55,411.55 L638.45,411.45 L638.25,411.35 L638.05,411.25 L637.85,411.15 L637.65,411.05 L637.35,411.05 L637.15,410.95 L636.95,410.95 L636.65,410.85 L636.45,410.85 L636.15,410.85 L635.95,410.85 L635.75,410.85 L627.45,410.85' />
      <path d='M643.75,466.15 L645.45,466.15 L645.45,466.05 L645.45,465.95 L645.45,465.85 L645.45,465.75 L645.45,465.65 L645.45,465.55 L645.45,465.45 L645.45,465.35 L645.05,465.35 L644.95,465.45 L644.95,465.55 L644.95,465.65 L644.95,465.75 L644.85,465.75 L644.75,465.75 L644.65,465.75 L644.55,465.75 L644.45,465.75 L644.35,465.75 L644.25,465.75 L644.25,465.65 L644.25,465.55 L644.25,465.45 L644.25,465.35 L643.75,465.35 L643.75,465.45 L643.75,465.55 L643.75,465.65 L643.75,465.75 L643.75,465.85 L643.75,465.95 L643.75,466.05 z' />
      <path d='M646.25,392.75 L645.75,392.75 L645.75,394.65' />
      <path d='M649.45,377.85 L649.35,377.95 L649.45,377.95 L649.45,377.85 L649.45,377.05 L649.45,376.95 L648.95,376.95 L648.85,376.95 L648.85,377.05 L648.85,377.55 L648.95,377.45 L649.05,377.45 L649.05,377.35 L649.15,377.35 L649.25,377.35 L649.35,377.45 L649.45,377.55 L649.35,377.45 L649.25,377.35 L649.15,377.35 L649.05,377.35 L649.05,377.45 L648.95,377.45 L648.85,377.55' />
      <path d='M651.15,443.95 L648.95,443.85' />
      <path d='M649.65,392.75 L650.25,392.75 L650.25,394.65' />
      <path d='M651.35,440.75 L651.15,440.75 L651.15,440.85 L651.15,440.95 L651.15,441.05 L651.15,441.15 L651.15,441.25 L651.15,441.45 L651.15,441.55 L651.15,441.75 L651.15,441.85 L651.15,442.05 L651.15,442.25 L651.15,442.45 L651.15,442.65 L651.15,442.85 L651.15,442.95 L651.15,443.15 L651.15,443.35 L651.15,443.45 L651.15,443.65 L651.15,443.75 L651.15,443.85 L651.15,443.95 L651.15,444.05 L651.35,444.05 L651.35,443.95 L651.35,443.85 L651.35,443.75 L651.35,443.65 L651.35,443.45 L651.35,443.35 L651.35,443.15 L651.35,442.95 L651.35,442.85 L651.35,442.65 L651.35,442.45 L651.35,442.25 L651.35,442.05 L651.35,441.85 L651.35,441.75 L651.35,441.55 L651.35,441.45 L651.35,441.25 L651.35,441.15 L651.35,441.05 L651.35,440.95 L651.35,440.85 z' />
      <path d='M648.95,445.35 L649.75,447.15 L649.85,447.25 L649.85,447.35 L649.95,447.45 L649.95,447.65 L649.95,447.75 L650.05,447.85 L650.05,447.95 L650.05,448.15 L650.25,452.95' />
      <path d='M649.45,377.05 L648.85,377.05' />
      <path d='M651.05,453.95 L650.75,448.05 L650.75,447.95 L650.75,447.75 L650.75,447.55 L650.65,447.45 L650.65,447.25 L650.55,447.15 L650.55,446.95 L650.45,446.85 L649.15,443.95' />
      <path d='M653.15,381.65 L652.65,381.65' />
      <path d='M647.15,377.55 L647.15,377.05 L647.05,377.05 L647.05,376.95 L646.55,376.95 L646.55,377.05 L646.45,377.05 L646.45,377.85 L646.45,377.95 L646.55,377.95 L646.65,377.95 L646.55,378.05 L646.45,378.25 L646.35,378.35 L646.35,378.55 L646.35,378.75 L646.25,378.95 L646.25,379.05 L646.25,379.15 L646.25,379.25 L646.25,379.35 L646.25,379.45 L646.25,379.65 L646.25,379.75 L646.25,379.95 L646.25,380.15 L646.25,380.45 L646.25,380.65 L646.25,380.95 L646.25,381.25 L646.25,381.55 L646.25,381.85 L646.25,382.25 L646.25,382.55 L646.25,382.95 L646.25,383.35 L646.25,383.75 L646.25,384.15 L646.25,384.65 L646.25,385.05 L646.25,385.55 L646.25,386.05 L646.25,386.45 L646.25,386.95 L646.25,387.55 L646.25,388.05 L646.25,388.55 L646.25,389.15 L646.25,389.65 L646.25,390.25 L646.25,390.85 L646.25,391.35 L646.25,391.95 L646.25,392.55 L646.25,393.15 L646.25,393.75 L646.25,394.35 L646.25,394.95 L646.25,395.55 L646.25,396.15 L646.25,396.75 L646.25,397.35 L646.25,397.95 L646.25,398.55 L646.25,399.15 L646.25,399.75 L646.25,400.35 L646.25,400.95 L646.25,401.55 L646.25,402.15 L646.25,402.75 L646.25,403.35 L646.25,403.85 L646.25,404.45 L646.25,404.95 L646.25,405.45 L646.25,406.05 L646.25,406.55 L646.25,407.05 L646.25,407.55 L646.25,408.05' />
      <path d='M645.65,452.95 L645.95,448.15 L645.95,447.95 L645.95,447.85 L645.95,447.75 L646.05,447.65 L646.05,447.45 L646.05,447.35 L646.15,447.25 L646.15,447.15 L647.05,445.35' />
      <path d='M646.85,443.95 L645.55,446.85 L645.45,446.95 L645.35,447.15 L645.35,447.25 L645.25,447.45 L645.25,447.55 L645.25,447.75 L645.15,447.95 L645.15,448.05 L644.85,453.95' />
      <path d='M647.15,377.05 L646.45,377.05' />
      <path d='M642.85,381.65 L643.35,381.65' />
      <path d='M642.25,412.35 L642.25,411.35 L642.25,411.15 L642.25,410.95 L642.25,410.75 L642.25,410.45 L642.25,410.25 L642.25,410.15 L642.25,409.95 L642.25,409.75 L642.25,409.65 L642.25,409.45 L642.25,409.35 L642.25,409.25 L642.25,409.15 L642.25,409.05' />
      <path d='M644.95,466.15 L644.95,491.25 L645.15,491.25' />
      <path d='M644.95,414.05 L644.95,440.95' />
      <path d='M644.95,443.95 L644.95,451.85' />
      <path d='M651.85,409.65 L651.85,412.35' />
      <path d='M650.35,398.95 L650.45,398.45' />
      <path d='M650.65,396.25 L650.35,394.65' />
      <path d='M646.25,443.95 L646.25,445.25' />
      <path d='M645.85,398.95 L646.05,397.45' />
      <path d='M646.05,396.15 L645.85,394.65' />
      <path d='M646.25,447.05 L646.25,451.85' />
      <path d='M651.85,414.05 L651.85,441.95' />
      <path d='M643.55,382.55 L643.45,382.55' />
      <path d='M650.15,394.65 L649.95,396.15' />
      <path d='M649.95,397.45 L650.15,398.95' />
      <path d='M649.75,491.25 L649.75,467.65' />
      <path d='M645.55,398.45 L645.65,398.95' />
      <path d='M650.25,467.65 L650.55,466.15' />
      <path d='M649.75,463.85 L649.75,457.25' />
      <path d='M650.15,372.75 L650.15,392.75' />
      <path d='M650.55,465.35 L650.25,463.85' />
      <path d='M645.75,463.85 L645.45,465.35' />
      <path d='M649.75,451.85 L649.75,447.05' />
      <path d='M645.45,466.15 L645.75,467.65' />
      <path d='M646.85,440.95 L644.75,440.95' />
      <path d='M649.75,445.25 L649.75,443.95' />
      <path d='M644.15,441.95 L644.15,414.05' />
      <path d='M643.15,386.75 L643.15,386.55' />
      <path d='M643.15,381.85 L643.15,381.65' />
      <path d='M651.15,440.95 L649.15,440.95' />
      <path d='M650.55,457.05 L650.95,465.35' />
      <path d='M649.75,440.95 L649.75,414.05' />
      <path d='M651.75,465.35 L651.25,456.35' />
      <path d='M645.05,465.35 L645.45,457.05' />
      <path d='M646.15,397.45 L646.15,407.95' />
      <path d='M644.15,412.35 L644.15,409.65' />
      <path d='M644.75,456.35 L644.25,465.35' />
      <path d='M651.35,442.95 L652.15,442.95' />
      <path d='M645.85,373.05 L650.15,373.05' />
      <path d='M652.15,441.95 L651.35,441.95' />
      <path d='M644.65,441.95 L644.05,441.95' />
      <path d='M650.15,392.95 L649.65,392.95' />
      <path d='M647.55,413.85 L648.35,413.85' />
      <path d='M652.85,386.75 L652.85,386.55' />
      <path d='M644.05,442.95 L644.65,442.95' />
      <path d='M641.75,408.95 L641.75,409.05' />
      <path d='M646.25,392.95 L645.85,392.95' />
      <path d='M645.15,465.35 L645.15,462.25' />
      <path d='M650.75,462.25 L650.75,465.35' />
      <path d='M645.85,400.65 L645.75,400.65' />
      <path d='M649.75,411.15 L649.45,411.35' />
      <path d='M650.95,410.25 L650.95,412.35' />
      <path d='M650.95,414.05 L650.95,440.95' />
      <path d='M650.25,400.65 z' />
      <path d='M650.95,443.95 L650.95,451.85' />
      <path d='M644.95,410.25 L644.95,412.35' />
      <path d='M645.85,372.75 L645.85,392.75' />
      <path d='M652.45,382.55 z' />
      <path d='M652.85,381.85 L652.85,381.65' />
    </g>
  );
};

export default class Block extends React.Component {
  state = {
    transform: 'translate(0,0)',
    transformParent: 'translate(0,0)',
    transformGrandparent: 'translate(0,0)',
    height: 0,
    tX: 0,
    tY: 0,
    sc: 1,
    visible: false
  };
  componentDidUpdate(prevProps) {
    // if (prevProps.bikeConfiguration.dim !== this.props.bikeConfiguration.dim) {
    //   console.log('updated');
    // }
    if (
      prevProps.length !== this.props.length ||
      prevProps.width !== this.props.width ||
      prevProps.w !== this.props.w ||
      prevProps.h !== this.props.h
    ) {
      this.setState({ visible: false }, this.rescale);
    }
  }
  rescale = () => {
    const { group, sg } = this;
    const { file, m, h, flip } = this.props;

    let sc = 1;
    // if (!this.bbox) {
    if (group) {
      this.bbox = group.getBBox();

      // }

      const bbox = this.bbox;
      const x = bbox.x + bbox.width / 2;
      const y = bbox.y - 0;

      if (!flip || flip === 0 || Math.abs(flip) === 180) {
        sc = (h / bbox.height) * m;
      } else {
        sc = (h / bbox.width) * m;
      }

      this.setState(
        {
          tX: -x,
          tY: -y,
          sc,
          bbox,
          sg: this.bbox,
          transformGrandparent: `scale(${sc}) `,
          height: bbox.height,
          visible: true
        },
        () => {
          this.forceUpdate();
        }
      );
    }
  };
  componentDidMount() {
    setTimeout(() => this.rescale());
  }

  getDim = () => {
    // if(!this.sg) return
    // const bbox = this.sg.getBBox();
    // return bbox
  };

  dimOffset = 8;
  tick = 2;

  render() {
    const { dimOffset, tick } = this;
    const {
      transformGrandparent,
      transformParent,
      height,
      tX,
      tY,
      sc,
      bbox,
      sg,
      visible
    } = this.state;
    const { file, m, x, y, flip, h, dim, w, isSvg } = this.props;
    const bb = sg;
    return (
      <g
        className='rack-group-super'
        transform={`translate(${this.props.x},${this.props.y})`}
        ref={(node) => {
          this.sg = node;
        }}
        style={{ opacity: visible ? 1 : 0 }}
      >
        <g className='rack-group'>
          <g transform={transformGrandparent}>
            <g
              transform={`translate(${tX},${tY})`}
              ref={(node) => {
                this.group = node;
              }}
            >
              {file === 'VERTICAL' &&
                (isSvg ? VERTICAL_SVG(flip) : VERTICAL(flip, m))}
              {file === 'DOUBLE' &&
                (isSvg ? DOUBLE_SVG(flip) : DOUBLE(flip, m))}
              {file === 'VARSITY' &&
                (isSvg ? VARSITY_SVG(flip) : VARSITY(flip, m))}
            </g>
          </g>
        </g>
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/svg/SVGBlock.js